<template>
    <div>
        <v-row class="mb-2 px-2 px-md-4">
            <v-col cols="12">
                <v-card class="pa-4 fade-card" :color="'#FBFAF1'" outlined>
                    <v-row dense>
                        <v-col cols="12" :md="admin ? 6 : 12">
                            <v-select background-color="white" v-model="selectedCamino" :items="caminosDisponibles"
                                :item-text="getTituloCamino" item-value="id" :label="$t('mensajes.central_reservas.selecciona_camino')" outlined dense
                                hide-details></v-select>
                        </v-col>
                        <v-col cols="12" md="6" v-if="admin">
                            <v-select background-color="white" v-model="selectedAgencia" :items="agencias"
                                item-text="nombre" item-value="identificador" :label="$t('mensajes.central_reservas.selecciona_agencia_origen')"
                                outlined dense hide-details></v-select>
                        </v-col>
                    </v-row>
                    <v-row dense class="mt-6 mb-4">
                        <v-col cols="12" :md="admin ? 6 : 12">
                            <div class="text-caption grey--text text--darken-1 mb-1">
                                {{ $t('mensajes.central_reservas.idioma_documentacion') }}
                            </div>
                            <v-radio-group v-model="selectedLanguage" row hide-details class="mt-0 pt-0">
                                <v-radio :label="$t('mensajes.central_reservas.idioma_es')" value="ES"></v-radio>
                                <v-radio :label="$t('mensajes.central_reservas.idioma_en')" value="EN"></v-radio>
                                <v-radio :label="$t('mensajes.central_reservas.idioma_de')" value="DE"></v-radio>
                            </v-radio-group>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>

        <template v-if="mostrarSolicitud">
            <v-row class="mb-2 px-2 px-md-4">
                <v-col cols="12">
                    <v-card class="pa-4 fade-card" :color="'#FBFAF1'" outlined>
                        <v-container>
                            <!-- Barra Superiorde navegación Stepper-->
                            <v-row class="mb-6">
                                <v-col cols="12">
                                    <v-card class="elevation-0 slide-card" style="background-color: transparent;">
                                        <v-card-text>
                                            <v-row justify="space-between">
                                                <v-spacer></v-spacer>

                                                <v-chip label x-large link @click="step > 1 ? _cambiarStep(1) : null"
                                                    class="ma-2 px-8" :color="step >= 1 ? miColorVerde : miColorNaranja"
                                                    :text-color="step >= 1 ? 'white' : miColorAzul"
                                                    style="font-size: 1.2rem;">
                                                    <v-icon size="2rem" left>mdi-calendar-check</v-icon>
                                                    {{ $t('mensajes.datos_de_reserva') }}
                                                </v-chip>

                                                <!--  <div class="mt-10 footprints-container">
                                    <v-icon v-for="n in 3" :key="n" 
                                        :color="step >= 2 ? miColorAzul : miColorNaranja"
                                        class="mx-2 footprint"
                                        style="transform: rotate(-6030deg);">
                                        mdi-shoe-print
                                    </v-icon>
                                </div>
                                -->
                                                <v-divider class="mt-10"
                                                    :style="{ borderBottom: '4px dashed ' + (step >= 2 ? miColorVerde : miColorNaranja), borderTop: 'none' }"></v-divider>

                                                <v-chip label x-large link
                                                    @click="step > 2 || (step === 1 && datosMinimosCompletados) ? _cambiarStep(2) : null"
                                                    class="ma-2 px-8" :color="step >= 2 ? miColorVerde : miColorNaranja"
                                                    :text-color="step >= 2 ? 'white' : miColorAzul"
                                                    style="font-size: 1.2rem;">
                                                    <v-icon size="2rem" left>mdi-check-circle</v-icon>
                                                    {{ $t('mensajes.servicios.tab_servicios') }}
                                                </v-chip>
                                                <v-divider class="mt-10"
                                                    :style="{ borderBottom: '4px dashed ' + (step >= 3 ? miColorVerde : miColorNaranja), borderTop: 'none' }"></v-divider>

                                                <v-chip label x-large link
                                                    @click="datosMinimosCompletados ? _cambiarStep(3) : null"
                                                    class="ma-2 px-8" :color="step >= 3 ? miColorVerde : miColorNaranja"
                                                    :text-color="step >= 3 ? 'white' : miColorAzul"
                                                    style="font-size: 1.2rem;">
                                                    <v-icon size="2rem" left>mdi-account-circle</v-icon>
                                                    {{ $t('mensajes.datos_personales') }}
                                                </v-chip>

                                                <v-divider class="mt-10"
                                                    :style="{ borderBottom: '4px dashed ' + (step >= 4 ? miColorVerde : miColorNaranja), borderTop: 'none' }"></v-divider>

                                                <v-icon size="4rem"
                                                    :color="step === 4 ? miColorVerde : miColorNaranja">mdi-flag-checkered</v-icon>


                                                <v-spacer></v-spacer>

                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                </v-col>

                            </v-row>

                            <v-row justify="center">
                                <v-col align="center">
                                    <!-- Step 1: Datos de la reserva -->
                                    <v-card v-if="step === 1" class="mx-4 pa-4 card-personalizada slide-card"
                                        style="min-width: 500px; width: 500px;">
                                        <v-card-title>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col class="text-center">
                                                    <p style="font-size: 1.2rem;" class="mx-16">
                                                        {{ $t('mensajes.preguntaPaso1') }}

                                                    </p>
                                                </v-col>
                                            </v-row>

                                         <!--   <v-row dense class="mx-4 mt-6 mb-4">
                                                <v-col cols="8" class="pa-0">
                                                    <v-text-field v-model="modelReserva.codigo_agencia" dense outlined
                                                        hide-details="auto" label="Código de la reserva en la Agencia"
                                                        required />
                                                </v-col>
                                            </v-row> -->

                                            <v-row dense class="mx-4 mt-2 mb-4">
                                                <v-spacer>
                                                    <v-menu v-model="showFechaInicio" :close-on-content-click="false"
                                                        :nudge-right="40" transition="scale-transition" offset-y
                                                        min-width="290px">
                                                        <template v-slot:activator="{ on }">
                                                            <v-text-field class="mr-2" clearable dense outlined
                                                                :value="formatearFecha(modelReserva.fecha_inicio)"
                                                                :label="$t('mensajes.datos_reserva.fechas_seleccion')"
                                                                prepend-inner-icon="mdi-calendar" readonly v-on="on"
                                                                hide-details></v-text-field>
                                                        </template>
                                                        <v-date-picker :color="miColorNaranja" :locale="$i18n.locale"
                                                            v-model="modelReserva.fecha_inicio"
                                                            @input="showFechaInicio = false"
                                                            @change="_changeFechaInicio()" first-day-of-week="1"
                                                            :min="new Date(Date.now() + RESERVAS_CONFIG.DIAS_MINIMOS_PARA_CREAR_RESERVA * 24 * 60 * 60 * 1000).toISOString().split('T')[0]"
                                                            :max="RESERVAS_CONFIG.FECHA_MAXIMA_RESERVA">
                                                        </v-date-picker>
                                                    </v-menu>
                                                </v-spacer>



                                            </v-row>




                                            <v-row dense align="center" class="mx-4 mt-10">
                                                <v-col align="end" cols="7">
                                                    <span style="font-size: 0.9rem;">{{
                                                        $t('mensajes.datos_reserva.habitaciones_individuales') }}</span>
                                                </v-col>
                                                <v-col>
                                                    <v-chip class="ml-2" label link :color="modelReserva.cant_habitaciones_individuales > 0
                                                        ? miColorAzul
                                                        : 'blue-grey lighten-4'
                                                        " @click="_setCantidadHabitacionesIndividuales('-')">
                                                        <h3 v-bind:style="{ color: 'white' }">-</h3>
                                                    </v-chip>

                                                    <v-chip class="mx-2" label color="black" outlined>
                                                        <span v-bind:style="{ color: 'black' }">
                                                            <h3>{{ modelReserva.cant_habitaciones_individuales }}</h3>
                                                        </span>
                                                    </v-chip>
                                                    <v-chip label link :color="miColorAzul"
                                                        @click="_setCantidadHabitacionesIndividuales('+')">
                                                        <h3 v-bind:style="{ color: 'white' }">+</h3>
                                                    </v-chip>
                                                </v-col>
                                            </v-row>

                                            <v-row dense align="center" class="mx-4">
                                                <v-col align="end" cols="7">
                                                    <span style="font-size: 0.9rem;">{{
                                                        $t('mensajes.datos_reserva.habitaciones_dobles_matrimoniales')
                                                    }}</span>
                                                </v-col>
                                                <v-col>
                                                    <v-chip class="ml-2" label link :color="modelReserva.cant_habitaciones_dobles_matrimoniales > 0
                                                        ? miColorAzul
                                                        : 'blue-grey lighten-4'
                                                        " @click="_setCantidadHabitacionesDoblesMatrimoniales('-')">
                                                        <h3 v-bind:style="{ color: 'white' }">-</h3>
                                                    </v-chip>

                                                    <v-chip class="mx-2" label color="black" outlined>
                                                        <span v-bind:style="{ color: 'black' }">
                                                            <h3>{{ modelReserva.cant_habitaciones_dobles_matrimoniales
                                                            }}</h3>
                                                        </span>
                                                    </v-chip>
                                                    <v-chip label link :color="miColorAzul"
                                                        @click="_setCantidadHabitacionesDoblesMatrimoniales('+')">
                                                        <h3 v-bind:style="{ color: 'white' }">+</h3>
                                                    </v-chip>
                                                </v-col>
                                            </v-row>

                                            <v-row dense align="center" class="mx-4">
                                                <v-col align="end" cols="7">
                                                    <span style="font-size: 0.9rem;">{{
                                                        $t('mensajes.datos_reserva.habitaciones_dobles')
                                                    }}</span>
                                                </v-col>
                                                <v-col>
                                                    <v-chip class="ml-2" label link :color="modelReserva.cant_habitaciones_dobles > 0
                                                        ? miColorAzul
                                                        : 'blue-grey lighten-4'
                                                        " @click="_setCantidadHabitacionesDobles('-')">
                                                        <h3 v-bind:style="{ color: 'white' }">-</h3>
                                                    </v-chip>

                                                    <v-chip class="mx-2" label color="black" outlined>
                                                        <span v-bind:style="{ color: 'black' }">
                                                            <h3>{{ modelReserva.cant_habitaciones_dobles }}</h3>
                                                        </span>
                                                    </v-chip>
                                                    <v-chip label link :color="miColorAzul"
                                                        @click="_setCantidadHabitacionesDobles('+')">
                                                        <h3 v-bind:style="{ color: 'white' }">+</h3>
                                                    </v-chip>
                                                </v-col>
                                            </v-row>



                                            <v-row dense align="center" class="mx-4">
                                                <v-col align="end" cols="7">
                                                    <span style="font-size: 0.9rem;">{{
                                                        $t('mensajes.datos_reserva.habitaciones_triples') }}</span>
                                                </v-col>
                                                <v-col>
                                                    <v-chip class="ml-2" label link :color="modelReserva.cant_habitaciones_triples > 0
                                                        ? miColorAzul
                                                        : 'blue-grey lighten-4'
                                                        " @click="_setCantidadHabitacionesTriples('-')">
                                                        <h3 v-bind:style="{ color: 'white' }">-</h3>
                                                    </v-chip>

                                                    <v-chip class="mx-2" label color="black" outlined>
                                                        <span v-bind:style="{ color: 'black' }">
                                                            <h3>{{ modelReserva.cant_habitaciones_triples }}</h3>
                                                        </span>
                                                    </v-chip>
                                                    <v-chip label link :color="miColorAzul"
                                                        @click="_setCantidadHabitacionesTriples('+')">
                                                        <h3 v-bind:style="{ color: 'white' }">+</h3>
                                                    </v-chip>
                                                </v-col>
                                            </v-row>

                                            <v-row dense align="center" class="mx-4 mt-10">
                                                <v-col align="end" cols="7">
                                                    <h3>{{ $t('mensajes.datos_reserva.cantidad_de_peregrinos') }}</h3>
                                                </v-col>
                                                <v-col>
                                                    <v-chip class="ml-2" label link :color="modelReserva.cant_peregrinos > 0
                                                        ? miColorAzul
                                                        : 'blue-grey lighten-4'
                                                        " @click="_setCantidadPeregrinos('-')">
                                                        <h3 v-bind:style="{ color: 'white' }">-</h3>
                                                    </v-chip>

                                                    <v-chip class="mx-2" label color="black" outlined>
                                                        <span v-bind:style="{ color: 'black' }">
                                                            <h3>{{ modelReserva.cant_peregrinos }}</h3>
                                                        </span>
                                                    </v-chip>
                                                    <v-chip label link :color="miColorAzul"
                                                        @click="_setCantidadPeregrinos('+')">
                                                        <h3 v-bind:style="{ color: 'white' }">+</h3>
                                                    </v-chip>
                                                </v-col>
                                            </v-row>

                                            <v-row dense class="mx-4 mt-10">
                                                <v-textarea :rows="5" outlined v-model="modelReserva.comentarios"
                                                    :placeholder="$t('mensajes.datos_reserva.comentarios')">
                                                </v-textarea>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <!-- Step 2: Servicios -->
                                    <v-card v-if="step === 2" class="mx-4 pa-4 card-personalizada slide-card"
                                        style="min-width: 500px;">
                                        <v-card-title>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row justify="center" class="mb-4">
                                                <h1> {{ $t('mensajes.servicios.opcionales_titulo') }}</h1>
                                            </v-row>
                                            <v-list dense>
                                                <v-list-item class="mb-1" v-for="servicio in serviciosNoIncluidos"
                                                    :key="servicio.id">
                                                    <v-list-item-icon>
                                                        <v-switch v-model="servicio.seleccionado" color="success"
                                                            hide-details dense inset class="mt-0"
                                                            @change="onServicioSeleccionado(servicio)"></v-switch>
                                                    </v-list-item-icon>
                                                    <v-list-item-content align="start">
                                                        <v-list-item-title>
                                                            <span
                                                                style="font-size: 1rem; white-space: normal; word-break: break-word;  line-height: 1.4; overflow: visible;">
                                                                {{ getTituloServicio(servicio) }}
                                                            </span>

                                                            <v-chip
                                                                v-if="servicio.titulo == 'Noche extra' && servicio.seleccionado"
                                                                color="success" small class="ml-4" label link
                                                                @click="_agregarNocheExtraVacia('')">
                                                                Agregar nueva noche
                                                            </v-chip>

                                                            <v-chip
                                                                v-if="servicio.titulo == 'Traslados extra' && servicio.seleccionado"
                                                                color="success" small class="ml-4" label link
                                                                @click="_agregarTrasladoExtraVacio()">
                                                                Agregar traslado extra
                                                            </v-chip>

                                                            <v-chip
                                                                v-if="servicio.titulo == 'Servicios extra' && servicio.seleccionado"
                                                                color="success" small class="ml-4" label link
                                                                @click="_agregarServicioExtraVacio()">
                                                                Agregar servicio extra
                                                            </v-chip>
                                                        </v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <!--  || (servicio.titulo != 'Noche extra' || !servicio.titulo.includes('Traslado privado a'))-->
                                                            <span
                                                                style="font-size: 1rem; white-space: normal; word-break: break-word;  line-height: 1.4; overflow: visible;">
                                                                {{ _getSubtitulo(servicio) }}
                                                            </span>
                                                        </v-list-item-subtitle>
                                                        <div class="mt-2"
                                                            v-if="(servicio.titulo == 'Noche extra' && servicio.seleccionado)">
                                                            <v-card class="mb-2 pt-4 pb-0 px-0 elevation-0"
                                                                v-for="(noche, index) in nochesextras" :key="index"
                                                                outlined>
                                                                <v-card-text>
                                                                    <v-row class="mb-2 mx-1">
                                                                        <v-select v-model="noche.localidad"
                                                                            :items="listadoPuntosFinales"
                                                                            label="Localidad" outlined dense
                                                                            hide-details></v-select>

                                                                    </v-row>
                                                                    <v-row v-if="admin">
                                                                        <v-col>
                                                                            <v-text-field
                                                                                v-if="modelReserva.cant_habitaciones_individuales > 0"
                                                                                v-model="noche.tarifa_ind"
                                                                                label="Individual" type="text" outlined
                                                                                dense hide-details></v-text-field>
                                                                        </v-col>
                                                                        <v-col>
                                                                            <v-text-field
                                                                                v-if="modelReserva.cant_habitaciones_dobles > 0 || modelReserva.cant_habitaciones_dobles_matrimoniales > 0"
                                                                                v-model="noche.tarifa_doble"
                                                                                label="Doble" type="text" outlined dense
                                                                                hide-details></v-text-field>
                                                                        </v-col>
                                                                        <v-col>
                                                                            <v-text-field
                                                                                v-if="modelReserva.cant_habitaciones_triples > 0"
                                                                                v-model="noche.tarifa_triple"
                                                                                label="Triple" type="text" outlined
                                                                                dense hide-details></v-text-field>
                                                                        </v-col>
                                                                    </v-row>

                                                                    <v-row justify="end">
                                                                        <v-chip color="error" small label link
                                                                            @click="onEliminarNoche(index)">
                                                                            Eliminar noche
                                                                        </v-chip>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>

                                                        <div class="mt-2"
                                                            v-if="(servicio.titulo == 'Traslados extra' && servicio.seleccionado)">
                                                            <v-card class="mb-2 pt-4 pb-0 px-0 elevation-0"
                                                                v-for="(traslado, index) in trasladosExtras"
                                                                :key="index" outlined>
                                                                <v-card-text>
                                                                    <v-row>
                                                                        <v-col cols="8">
                                                                            <v-text-field v-model="traslado.descripcion"
                                                                                label="Descripción" type="text"
                                                                                placeholder="Descripción" outlined dense
                                                                                hide-details></v-text-field>
                                                                        </v-col>
                                                                        <v-col v-if="admin">
                                                                            <v-text-field v-model="traslado.importe"
                                                                                label="Importe" type="text" outlined
                                                                                dense hide-details></v-text-field>
                                                                        </v-col>
                                                                    </v-row>


                                                                    <v-row justify="end">
                                                                        <v-chip color="error" small label link
                                                                            @click="onEliminarTrasladoExtra(index)">
                                                                            Eliminar traslado
                                                                        </v-chip>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>

                                                        <div class="mt-2"
                                                            v-if="(servicio.titulo == 'Servicios extra' && servicio.seleccionado)">
                                                            <v-card class="mb-2 pt-4 pb-0 px-0 elevation-0"
                                                                v-for="(servicioExtra, index) in serviciosExtras"
                                                                :key="index" outlined>
                                                                <v-card-text>
                                                                    <v-row>
                                                                        <v-col cols="8">
                                                                            <v-text-field
                                                                                v-model="servicioExtra.descripcion"
                                                                                label="Descripción" type="text"
                                                                                placeholder="Descripción" outlined dense
                                                                                hide-details></v-text-field>
                                                                        </v-col>
                                                                        <v-col v-if="admin">
                                                                            <v-text-field
                                                                                v-model="servicioExtra.importe"
                                                                                label="Importe" type="text" outlined
                                                                                dense hide-details></v-text-field>
                                                                        </v-col>
                                                                    </v-row>


                                                                    <v-row justify="end">
                                                                        <v-chip color="error" small label link
                                                                            @click="onEliminarServicioExtra(index)">
                                                                            Eliminar servicio
                                                                        </v-chip>
                                                                    </v-row>
                                                                </v-card-text>
                                                            </v-card>
                                                        </div>




                                                        <div class="mt-2"
                                                            v-if="servicio.titulo.includes('Traslado privado') && servicio.seleccionado">
                                                            <v-row>
                                                                <v-col cols="8">
                                                                    <v-text-field v-model="servicio.descripcion"
                                                                        label="Descripción" type="text"
                                                                        placeholder="Descripción" outlined dense
                                                                        hide-details></v-text-field>
                                                                </v-col>
                                                                <v-col v-if="admin">
                                                                    <v-text-field v-model="servicio.importe"
                                                                        label="Importe" type="text" outlined dense
                                                                        hide-details></v-text-field>
                                                                </v-col>
                                                            </v-row>
                                                        </div>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>

                                            <v-row v-if="step > 1" justify="center" class="mt-6 mb-4">
                                                <div ref="serviciosIncluidosCentral"></div>
                                                <h1> {{ $t('mensajes.servicios.incluidos_titulo') }}</h1>
                                            </v-row>
                                           <!-- <v-row v-if="step > 1" class="mt-6 mb-4 mx-6">
                                                <span style="text-align: start;"> {{
                                                    $t('mensajes.servicios.incluidos_subtitulo') }}
                                                </span>
                                            </v-row> -->


                                            <v-list v-if="step > 1" dense>
                                                <v-list-item class="mb-1" v-for="servicio in serviciosIncluidos"
                                                    :key="servicio.id">
                                                    <v-list-item-icon v-if="servicio.seleccionado">
                                                        <v-icon color="green" style="font-size: 2rem;">mdi-check-circle</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-icon v-else>
                                                        <v-icon color="red" style="font-size: 2rem;">mdi-close-circle</v-icon>
                                                    </v-list-item-icon>
                                                    <v-list-item-content align="start">
                                                        <v-list-item-title>
                                                            <span
                                                                style="font-size: 1rem; white-space: normal; word-break: break-word;  line-height: 1.4; overflow: visible;">{{
                                                                    getTituloServicio(servicio) }}</span>
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>

                                        </v-card-text>
                                    </v-card>
                                    <!-- Step 3: Datos personales -->
                                    <v-card v-if="!esAgencia && step === 3"
                                        class="mx-4 pa-4 card-personalizada slide-card"
                                        style="min-width: 500px; width: 500px;">
                                        <v-card-title>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row class="mb-4">
                                                <v-col class="text-center">
                                                    <p style="font-size: 1.2rem;" class="mx-16">
                                                        {{ $t('mensajes.preguntaPaso2') }}

                                                    </p>
                                                </v-col>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="modelReserva.cliente.nombre" class="mx-4 mb-2"
                                                    :label="$t('mensajes.nombre')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="modelReserva.cliente.apellidos" class="mx-4 mb-2"
                                                    :label="$t('mensajes.apellidos')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-col cols="5" class="pr-0">
                                                    <v-select v-model="codigoPaisSeleccionado" :items="codigosPais"
                                                        item-text="name" item-value="code" outlined dense hide-details
                                                        class="mx-4" return-object>
                                                        <template v-slot:selection="{ item }">
                                                            <template v-if="codigoPaisSeleccionado">
                                                                <span
                                                                    :class="`flag-icon flag-icon-${codigoPaisSeleccionado.code.toLowerCase()}`"
                                                                    class="mr-2"></span>
                                                                {{ codigoPaisSeleccionado.dial_code }}
                                                            </template>
                                                        </template>
                                                        <template v-slot:item="{ item }">
                                                            <span
                                                                :class="`flag-icon flag-icon-${item.code.toLowerCase()}`"
                                                                class="mr-2"></span>
                                                            {{ item.name }} ({{ item.dial_code }})
                                                        </template>
                                                    </v-select>
                                                </v-col>
                                                <v-col cols="7" class="pl-0">
                                                    <v-text-field v-model="modelReserva.cliente.telefono"
                                                        class="mx-4 mb-2" :label="$t('mensajes.telefono')" type="text"
                                                        outlined dense autocomplete="off" hide-details></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="modelReserva.cliente.email" class="mx-4 mb-2"
                                                    :label="$t('mensajes.email')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <!--<v-row dense class="mx-2" align="center">
                                <v-checkbox v-model="modelReserva.cliente.aceptaPolitica" required :ripple="false"
                                    class="mr-1" :label="$t('mensajes.politica_privacidad')"></v-checkbox>
                                <a :href="$t('mensajes.politica_privacidad_enlace')" target="_blank"
                                    style="text-decoration: none; font-size: 1rem;">
                                    {{ $t('mensajes.politica_privacidad_texto_enlace') }}
                                </a>
                            </v-row>-->

                                            <!--   <v-row dense class="mx-2 mb-4" align="center">
                                                <v-checkbox hide-details v-model="modelReserva.cliente.aceptaNovedades"
                                                    required :ripple="false" class="mr-1"
                                                    :label="$t('mensajes.acepta_novedades')"></v-checkbox>
                                            </v-row>
                                            -->


                                        </v-card-text>
                                    </v-card>
                                    <!-- Step 3: Datos de la agencia -->
                                    <v-card v-if="esAgencia && step === 3"
                                        class="mx-4 pa-4 card-personalizada slide-card"
                                        style="min-width: 500px; width: 500px;">
                                        <v-card-title>
                                        </v-card-title>
                                        <v-card-text>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="agencia.nombre" class="mx-4 mb-2" disabled
                                                    :label="$t('mensajes.central_reservas.nombre_agencia')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="agencia.telefono" class="mx-4 mb-2" disabled
                                                    :label="$t('mensajes.central_reservas.telefono_agencia')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="agencia.email" class="mx-4 mb-2" disabled
                                                    :label="$t('mensajes.central_reservas.email_agencia')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <v-divider></v-divider>


                                            <v-row v-if="!bloquearEmailClientePorPendientes" class="mt-2 mb-2">
                                                <v-col justify="start">
                                                    <p style="font-size: 1rem; white-space: pre-line;" class="mx-0">
                                                        {{ $t('mensajes.central_reservas.instrucciones_cliente') }}
                                                    </p>
                                                </v-col>
                                            </v-row>

                                            <v-row v-else class="mt-2 mb-2">
                                                <v-col justify="start">
                                                    <p style="font-size: 1rem; white-space: pre-line;" class="mx-0">
                                                        {{ $t('mensajes.central_reservas.instrucciones_cliente_pendientes') }}
                                                    </p>
                                                </v-col>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="modelReserva.cliente.nombre" class="mx-4 mb-2"
                                                    :label="$t('mensajes.central_reservas.nombre_cliente')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="modelReserva.cliente.apellidos" class="mx-4 mb-2"
                                                    :label="$t('mensajes.central_reservas.apellidos_cliente')" type="text" outlined dense
                                                    autocomplete="off" hide-details>
                                                </v-text-field>
                                            </v-row>

                                               <v-row dense class="mx-2 mb-4">
                                <v-col cols="5" class="pr-0">
                                    <v-select v-model="codigoPaisSeleccionado" :items="codigosPais" item-text="name"
                                        item-value="code" outlined dense hide-details class="mx-4" return-object>
                                        <template v-slot:selection="{ item }">
                                            <template v-if="codigoPaisSeleccionado">
                                                <span
                                                    :class="`flag-icon flag-icon-${codigoPaisSeleccionado.code.toLowerCase()}`"
                                                    class="mr-2"></span>
                                                {{ codigoPaisSeleccionado.dial_code }}
                                            </template>
                                        </template>
                                        <template v-slot:item="{ item }">
                                            <span :class="`flag-icon flag-icon-${item.code.toLowerCase()}`"
                                                class="mr-2"></span>
                                            {{ item.name }} ({{ item.dial_code }})
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="7" class="pl-0">
                                    <v-text-field v-model="modelReserva.cliente.telefono" class="mx-4 mb-2"
                                        :label="$t('mensajes.telefono')" type="text" outlined dense autocomplete="off"
                                        hide-details></v-text-field>
                                </v-col> 
                            </v-row> 

                                            

                                            <v-row dense class="mx-2 mb-4">
                                                <v-text-field v-model="modelReserva.cliente.email" class="mx-4 mb-2"
                                                    :label="$t('mensajes.central_reservas.email_cliente')" type="text" outlined dense
                                                    autocomplete="off"
                                                    hide-details>
                                                </v-text-field>
                                            </v-row>

                                            <v-row v-if="bloquearEmailClientePorPendientes" dense class="mx-2 mb-4">
                                                <v-col cols="12" class="px-4 pt-0">
                                                    <span class="error--text" style="font-size: 0.875rem;">
                                                        {{ $t('mensajes.central_reservas.aviso_cliente_servicios_pendientes') }}
                                                    </span>
                                                </v-col>
                                            </v-row>

                                            
                         

                                            <!--  <v-row dense class="mx-2" align="center">
                                <v-checkbox v-model="modelReserva.cliente.aceptaPolitica" required :ripple="false"
                                    class="mr-1" :label="$t('mensajes.politica_privacidad')"></v-checkbox>
                                <a :href="$t('mensajes.politica_privacidad_enlace')" target="_blank"
                                    style="text-decoration: none; font-size: 1rem;">
                                    {{ $t('mensajes.politica_privacidad_texto_enlace') }}
                                </a>
                            </v-row>-->

                                            <!--    <v-row dense class="mx-2 mb-4" align="center">
                                                <v-checkbox hide-details v-model="modelReserva.cliente.aceptaNovedades"
                                                    required :ripple="false" class="mr-1"
                                                    :label="$t('mensajes.acepta_novedades')"></v-checkbox>
                                            </v-row> -->



                                        </v-card-text>
                                    </v-card>
                                    <!-- Step 5: Formulario de Pasajeros -->
                                    <v-card v-if="step === 5" class="mx-4 pa-4 card-personalizada slide-card"
                                        style="min-width: 500px; width: 500px;">
                                        <v-card-title>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row class="mt-0 mb-2">
                                                <v-col justify="start">
                                                    <p class="mx-0">
                                                        Para confirmar la reserva necsitamos rellene los datos
                                                        principales de todos los
                                                        datos de los
                                                        pasajeros.
                                                    </p>
                                                </v-col>
                                            </v-row>

                                            <div v-for="(pasajero, index) in pasajeros" :key="index">

                                                <v-row class="mt-0 mb-2">
                                                    <v-col justify="start">
                                                        <h2 class="mx-0">
                                                            Pasajero {{ index + 1 }}
                                                        </h2>
                                                    </v-col>
                                                </v-row>

                                                <v-row dense class="mx-2 mb-4">
                                                    <v-text-field v-model="pasajero.nombre" class="mx-4 mb-2"
                                                        label="Nombre" type="text" outlined dense autocomplete="off"
                                                        hide-details>
                                                    </v-text-field>
                                                </v-row>

                                                <v-row dense class="mx-2 mb-4">
                                                    <v-text-field v-model="pasajero.primer_apellido" class="mx-4 mb-2"
                                                        label="Apellidos" type="text" outlined dense autocomplete="off"
                                                        hide-details>
                                                    </v-text-field>
                                                </v-row>

                                                <v-row dense class="mx-2 mb-4">
                                                    <v-col cols="5" class="pr-0">
                                                        <v-select v-model="pasajero.tipo_documento"
                                                            :items="tipoDeDocumentos" item-text="name"
                                                            item-value="value" outlined dense hide-details class="mx-4">
                                                        </v-select>
                                                    </v-col>
                                                    <v-col cols="7" class="pl-0">
                                                        <v-text-field v-model="pasajero.documento" class="mx-4 mb-2"
                                                            label="Documento"
                                                            :error="!isValidDocument(pasajero.tipo_documento, pasajero.documento)"
                                                            type="text" outlined dense autocomplete="off" hide-details
                                                            @input="pasajero.documento = $event.toUpperCase()">
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-divider class="mb-4"></v-divider>

                                            </div>





                                        </v-card-text>
                                    </v-card>
                                </v-col>
                                <!-- Ticket de Compra cuando es Peregrino -->
                                <v-col v-if="!esAgencia && camino && step !== 4" align="center">
                                    <v-card class="mx-4 card-personalizada slide-card"
                                        style="background-color: #DDFFDD; min-width: 500px; width: 500px;">
                                        <v-card-title style="background-color: #DDFFDD; text-align: center;">
                                            <h1 style="font-size: 1.2rem;" class="mx-4">
                                                {{ $t('mensajes.datos_reserva.titulo') }}
                                            </h1>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row dense>

                                                <v-col align="center">
                                                    <h3> {{ getTituloCamino(this.camino) }}
                                                    </h3>
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="modelReserva.fecha_inicio">
                                                <v-col cols="6" align="end">
                                                    {{ $t('mensajes.datos_reserva.fecha_inicio') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.fecha_inicio }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="modelReserva.fecha_llegada">
                                                <v-col cols="6" align="end">
                                                    {{ $t('mensajes.datos_reserva.fecha_llegada') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.fecha_llegada }}
                                                </v-col>
                                            </v-row>

                                            <v-row class="mt-4" dense v-if="datosMinimosCompletados">
                                                <v-col cols="4" align="end">
                                                    {{ $t('mensajes.datos_reserva.habitaciones') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.cant_habitaciones_individuales +
                                                        this.modelReserva.cant_habitaciones_dobles +
                                                        this.modelReserva.cant_habitaciones_dobles_matrimoniales +
                                                        this.modelReserva.cant_habitaciones_triples }}
                                                    ( {{ this.modelReserva.cant_habitaciones_individuales ?
                                                        this.modelReserva.cant_habitaciones_individuales +
                                                        (this.$i18n.locale === 'de' ? ' Einzelzimmer' :
                                                            this.$i18n.locale === 'en' ? ' single ' :
                                                                ' individuales') : '' }} {{
                                                        this.modelReserva.cant_habitaciones_dobles ?
                                                            this.modelReserva.cant_habitaciones_dobles +
                                                            (this.$i18n.locale === 'es' ? ' dobles [2 camas Ind] ' :
                                                                this.$i18n.locale === 'de' ? ' Doppelzimmer [2 Einzelbetten]' :
                                                                    this.$i18n.locale === 'en' ? ' double room [2 single beds]' :
                                                                        ' dobles [2 camas Ind])')
                                                            : '' }}
                                                    {{
                                                        this.modelReserva.cant_habitaciones_dobles_matrimoniales ?
                                                            this.modelReserva.cant_habitaciones_dobles_matrimoniales +
                                                            (this.$i18n.locale === 'es' ? ' dobles [cama matrimonial] ' :
                                                                this.$i18n.locale === 'de' ? ' Doppelzimmer [1 Doppelbett]' :
                                                                    this.$i18n.locale === 'en' ? ' double room [1 double bed]' :
                                                                        ' dobles [cama matrimonial]')
                                                            : '' }}
                                                    {{ this.modelReserva.cant_habitaciones_triples ?
                                                        this.modelReserva.cant_habitaciones_triples
                                                        + (this.$i18n.locale === 'es' ? ' triples ' :
                                                            this.$i18n.locale === 'de' ? ' Dreibettzimmer' :
                                                                this.$i18n.locale === 'en' ? ' triple' :
                                                                    ' triples')
                                                        : '' }})
                                                </v-col>
                                            </v-row>

                                            <v-row dense v-if="datosMinimosCompletados">
                                                <v-col cols="4" align="end">
                                                    {{ $t('mensajes.datos_reserva.peregrinos') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.cant_peregrinos }}
                                                </v-col>
                                            </v-row>

                                            <v-row class="mt-6" v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h3> {{ $t('mensajes.datos_reserva.importe_reserva') }} </h3>

                                                </v-col>
                                                <v-col align="end">
                                                    <h2>{{ importeReserva }} €</h2>
                                                </v-col>
                                            </v-row>
                                            <v-row dense class="mt-2" v-if="datosMinimosCompletados">
                                                <v-col align="end">
                                                    <p v-html="descripcionImporteReserva" />
                                                </v-col>
                                            </v-row>

                                            <v-row v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h3> {{ $t('mensajes.datos_reserva.servicios_agregados') }} </h3>
                                                </v-col>
                                                <v-col align="end">
                                                    <h2>{{ importeServiciosFormateado }}</h2>
                                                </v-col>
                                            </v-row>

                                            <v-row align="center" dense v-if="datosMinimosCompletados">


                                                <v-col align="end">
                                                    <p v-html="descripcionImporteServicios" />
                                                </v-col>


                                                <!--    <v-col v-if="servicio.titulo !== 'Noche extra' && servicio.seleccionado" cols="8" align="end">
                                    {{ getTituloServicio(servicio) }}
                                    <br>
                                    {{ _getSubtituloServicioWithPersona(servicio) }}
                                </v-col>
                                <v-col v-if="servicio.titulo !== 'Noche extra' && servicio.seleccionado" align="end">
                                    <span>{{ _calcularTarifaDeServicioWithPersona(servicio) == 0 ? ' - ' :
                                        _calcularTarifaDeServicioWithPersona(servicio) }}
                                        €</span>
                                </v-col>

                                <v-row class="mt-2" dense v-if="servicio.titulo == 'Noche extra' && servicio.seleccionado" v-for="noche in nochesextras" :key="noche.id">
                                    <v-col align="end">
                                        Noche extra en {{ noche.localidad }}.....
                                        {{ Number(noche.tarifa_ind * modelReserva.cant_habitaciones_individuales + 
                                           noche.tarifa_doble * modelReserva.cant_habitaciones_dobles + 
                                           noche.tarifa_doble * modelReserva.cant_habitaciones_dobles_matrimoniales +
                                           noche.tarifa_triple * modelReserva.cant_habitaciones_triples).toFixed(2) }} €
                                        <br>
                                            (
                                            <template v-if="modelReserva.cant_habitaciones_individuales > 0 && noche.tarifa_ind > 0">
                                                {{ modelReserva.cant_habitaciones_individuales }} Ind x {{ Number(noche.tarifa_ind).toFixed(2) }}€,
                                            </template>
                                            <template v-if="modelReserva.cant_habitaciones_dobles + modelReserva.cant_habitaciones_dobles_matrimoniales > 0 && noche.tarifa_doble > 0">
                                                {{ modelReserva.cant_habitaciones_dobles + modelReserva.cant_habitaciones_dobles_matrimoniales }} Doble x {{ Number(noche.tarifa_doble).toFixed(2) }}€,
                                            </template>
                                            <template v-if="modelReserva.cant_habitaciones_triples > 0 && noche.tarifa_triple > 0">
                                                {{ modelReserva.cant_habitaciones_triples }} Triple x {{ Number(noche.tarifa_triple).toFixed(2) }}€
                                            </template>
                                            )
                                        
                                    </v-col>
                                </v-row>
                            -->
                                            </v-row>

                                            <v-row v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h3> {{ $t('mensajes.datos_reserva.importe_total') }} </h3>
                                                </v-col>
                                                <v-col align="end">
                                                    <h2>{{ importeTotal }} €</h2>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-row v-if="datosMinimosCompletados && step < 3" class="mt-6 mb-6"
                                        justify="center">
                                        <v-chip link @click="_Siguiente" large class="ma-2 px-8 mr-8 hover-color"
                                            :color="miColorAzul" :text-color="miColorNaranja"
                                            style="font-size: 1.2rem;">
                                            {{ $t('mensajes.siguientePaso1') }}
                                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                        </v-chip>
                                    </v-row>

                                    <v-row v-if="datosMinimosCompletados && step === 2" class="mt-12 mb-6"
                                        justify="center">
                                        <v-chip link @click="scrollToServiciosIncluidos" large
                                            class="ma-2 px-8 mr-8 hover-color" :color="miColorAzul"
                                            :text-color="miColorNaranja" style="font-size: 1.2rem;">
                                            {{ $t('mensajes.servicios.ver_incluidos_boton') }}
                                            <v-icon size="2rem" right class="scroll-down-anim">mdi-chevron-double-down</v-icon>
                                        </v-chip>
                                    </v-row>

                                    <v-row v-if="step === 3" class="mt-4 mb-6" justify="center">
                                        <v-chip link @click="puedeRecibirPresupuesto ? _recibirPresupuesto() : null"
                                            large class="ma-2 px-8 mr-8"
                                            :class="{ 'hover-color': puedeRecibirPresupuesto }"
                                            :color="!puedeRecibirPresupuesto ? 'grey' : (step >= 1 ? miColorAzul : miColorNaranja)"
                                            :text-color="!puedeRecibirPresupuesto ? 'black' : (step >= 1 ? miColorNaranja : miColorAzul)"
                                            style="font-size: 1.2rem;" :disabled="!puedeRecibirPresupuesto">
                                            {{ $t('mensajes.recibir_presupuesto') }}
                                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                        </v-chip>
                                    </v-row>
                                </v-col>
                                <!-- Ticket de Compra cuando es Agencia -->
                                <v-col v-if="esAgencia && camino && step !== 4" align="center">
                                    <v-card class="mx-4 card-personalizada slide-card"
                                        style="background-color: #DDFFDD; min-width: 500px; width: 500px;">
                                        <v-card-title style="background-color: #DDFFDD; text-align: center;">
                                            <h1 style="font-size: 1.2rem;" class="mx-4">
                                                {{ $t('mensajes.datos_reserva.titulo') }}
                                            </h1>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row dense>

                                                <v-col align="center">
                                                    <h3> {{ getTituloCamino(this.camino) }}
                                                    </h3>
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="modelReserva.fecha_inicio">
                                                <v-col cols="6" align="end">
                                                    {{ $t('mensajes.datos_reserva.fecha_inicio') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.fecha_inicio }}
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="modelReserva.fecha_llegada">
                                                <v-col cols="6" align="end">
                                                    {{ $t('mensajes.datos_reserva.fecha_llegada') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.fecha_llegada }}
                                                </v-col>
                                            </v-row>

                                            <v-row class="mt-4" dense v-if="datosMinimosCompletados">
                                                <v-col cols="4" align="end">
                                                    {{ $t('mensajes.datos_reserva.habitaciones') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.cant_habitaciones_individuales +
                                                        this.modelReserva.cant_habitaciones_dobles +
                                                        this.modelReserva.cant_habitaciones_triples }}
                                                    ( {{ this.modelReserva.cant_habitaciones_individuales ?
                                                        this.modelReserva.cant_habitaciones_individuales +
                                                        (this.$i18n.locale === 'de' ? ' Einzelzimmer' :
                                                            this.$i18n.locale === 'en' ? ' single ' :
                                                                ' individuales') : '' }} {{
                                                        this.modelReserva.cant_habitaciones_dobles ?
                                                            this.modelReserva.cant_habitaciones_dobles +
                                                            (this.$i18n.locale === 'es' ? ' dobles (2 camas Ind) ' :
                                                                this.$i18n.locale === 'de' ? ' Doppelzimmer (2 Einzelbetten)' :
                                                                    this.$i18n.locale === 'en' ? ' double room (2 single beds)' :
                                                                        ' dobles (2 camas Ind)')
                                                            : '' }}
                                                    {{
                                                        this.modelReserva.cant_habitaciones_dobles_matrimoniales ?
                                                            this.modelReserva.cant_habitaciones_dobles_matrimoniales +
                                                            (this.$i18n.locale === 'es' ? ' dobles (cama matrimonial) ' :
                                                                this.$i18n.locale === 'de' ? ' Doppelzimmer (1 Doppelbett)' :
                                                                    this.$i18n.locale === 'en' ? ' double room (1 double bed)' :
                                                                        ' dobles (cama matrimonial)')
                                                            : '' }} {{ this.modelReserva.cant_habitaciones_triples ?
                                                        this.modelReserva.cant_habitaciones_triples
                                                        + (this.$i18n.locale === 'es' ? ' triples ' :
                                                            this.$i18n.locale === 'de' ? ' Dreibettzimmer' :
                                                                this.$i18n.locale === 'en' ? ' triple' :
                                                                    ' triples')
                                                        : '' }})
                                                </v-col>
                                            </v-row>

                                            <v-row dense v-if="datosMinimosCompletados">
                                                <v-col cols="4" align="end">
                                                    {{ $t('mensajes.datos_reserva.peregrinos') }}
                                                </v-col>
                                                <v-col align="start">
                                                    {{ this.modelReserva.cant_peregrinos }}
                                                </v-col>
                                            </v-row>

                                            <v-row dense class="mt-6" v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h3> {{ $t('mensajes.datos_reserva.importe_reserva') }} (PVP) </h3>
                                                </v-col>
                                                <v-col align="end">
                                                    <h2>{{ importeReserva }} €</h2>
                                                </v-col>
                                            </v-row>
                                            <v-row dense class="mt-0" v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h4> {{ comisionAgencia }}% Comisión Agencia </h4>
                                                </v-col>
                                                <v-col align="end">
                                                    <h3>{{ importeComision }} €</h3>
                                                </v-col>
                                            </v-row>
                                            <v-row dense class="mt-0" v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h4> Importe Neto Agencia </h4>
                                                </v-col>
                                                <v-col align="end">
                                                    <h3>{{ importeNeto }} €</h3>
                                                </v-col>
                                            </v-row>
                                            <v-row dense class="mt-2" v-if="datosMinimosCompletados">
                                                <v-col align="end">
                                                    <p v-html="descripcionImporteReserva" />
                                                </v-col>
                                            </v-row>

                                            <v-row v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h3 class="mb-0"> {{
                                                        $t('mensajes.datos_reserva.servicios_agregados') }} (Neto)
                                                    </h3>
                                                    <span class="mt-0" style="font-size: 0.8rem;"> {{
                                                        $t('mensajes.datos_reserva.no_comisionable') }}
                                                    </span>
                                                </v-col>
                                                <v-col align="end">
                                                    <h2>{{ importeServiciosFormateado }}</h2>
                                                </v-col>
                                            </v-row>

                                            <v-row align="center" dense v-if="datosMinimosCompletados">

                                                <v-col align="end">
                                                    <p v-html="descripcionImporteServicios" />
                                                </v-col>

                                                <!--    <v-col v-if="servicio.titulo !== 'Noche extra' && servicio.seleccionado" cols="8" align="end">
                                    {{ getTituloServicio(servicio) }}
                                    <br>
                                    {{ _getSubtituloServicioWithPersona(servicio) }}
                                </v-col>
                                <v-col v-if="servicio.titulo !== 'Noche extra' && servicio.seleccionado" align="end">
                                    <span>{{ _calcularTarifaDeServicioWithPersona(servicio) == 0 ? ' - ' :
                                        _calcularTarifaDeServicioWithPersona(servicio) }}
                                        €</span>
                                </v-col>

                                <v-row class="mt-2" dense v-if="servicio.titulo == 'Noche extra' && servicio.seleccionado" v-for="noche in nochesextras" :key="noche.id">
                                    <v-col align="end">
                                        Noche extra en {{ noche.localidad }}..... - €
                                    </v-col>
                                </v-row>
                            -->



                                            </v-row>

                                            <v-row class="mt-6" dense v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h3> {{ $t('mensajes.datos_reserva.importe_total') }} (PVP) </h3>
                                                </v-col>
                                                <v-col align="end">
                                                    <h2>{{ importeTotal }} €</h2>
                                                </v-col>
                                            </v-row>
                                            <v-row dense v-if="datosMinimosCompletados">
                                                <v-col cols="8" align="end">
                                                    <h3> {{ $t('mensajes.datos_reserva.importe_total') }} (Neto) </h3>
                                                </v-col>
                                                <v-col align="end">
                                                    <h3>{{ importeTotalNeto }} €</h3>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>
                                    <v-row v-if="datosMinimosCompletados && step < 3" class="mt-6 mb-6"
                                        justify="center">
                                        <v-chip link @click="_Siguiente" large class="ma-2 px-8 mr-8 hover-color"
                                            :color="miColorAzul" :text-color="miColorNaranja"
                                            style="font-size: 1.2rem;">
                                            {{ $t('mensajes.siguientePaso1') }}
                                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                        </v-chip>
                                    </v-row>

                                    <v-row v-if="datosMinimosCompletados && step === 2" class="mt-12 mb-6"
                                        justify="center">
                                        <v-chip link @click="scrollToServiciosIncluidos" large
                                            class="ma-2 px-8 mr-8 hover-color" :color="miColorAzul"
                                            :text-color="miColorNaranja" style="font-size: 1.2rem;">
                                            {{ $t('mensajes.servicios.ver_incluidos_boton') }}
                                            <v-icon size="2rem" right class="scroll-down-anim">mdi-chevron-double-down</v-icon>
                                        </v-chip>
                                    </v-row>

                                    <v-row v-if="step === 3" class="mt-4 mb-6" justify="center">
                                        <v-chip link
                                            @click="_activadoEnvioDePresupuestoDesdeAgencia() ? _recibirPresupuesto() : null"
                                            large class="ma-2 px-8 mr-8"
                                            :class="{ 'hover-color': _activadoEnvioDePresupuestoDesdeAgencia() }"
                                            :color="!_activadoEnvioDePresupuestoDesdeAgencia() ? 'grey' : (step >= 1 ? miColorAzul : miColorNaranja)"
                                            :text-color="!_activadoEnvioDePresupuestoDesdeAgencia() ? 'black' : (step >= 1 ? miColorNaranja : miColorAzul)"
                                            style="font-size: 1.2rem;"
                                            :disabled="!_activadoEnvioDePresupuestoDesdeAgencia()">
                                            {{ this._enviarPresupuestoAlClienteFinal() ?
                                                $t('mensajes.central_reservas.enviar_propuesta_cliente') :
                                                $t('mensajes.central_reservas.recibir_propuesta') }}
                                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                        </v-chip>

                                    <!--    <v-chip link large @click="_pedirDatosPasajeros()" class="ma-2 px-8 mr-8"
                                            :class="{ 'hover-color': puedeCompletarPeticionReserva }"
                                            :color="!puedeCompletarPeticionReserva ? 'grey' : (step >= 1 ? miColorAzul : miColorNaranja)"
                                            :text-color="!puedeCompletarPeticionReserva ? 'black' : (step >= 1 ? miColorNaranja : miColorAzul)"
                                            style="font-size: 1.2rem;" :disabled="!puedeCompletarPeticionReserva">
                                            Completar Petición de Reserva
                                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                        </v-chip> 
                                    -->
                                        


                                    </v-row>

                                    <v-row v-if="step === 5" justify="center" class="mt-4">
                                        <v-chip link large @click="_enviarConfirmacionReserva()" class="ma-2 px-8 mr-8"
                                            :class="{ 'hover-color': datosPasajerosCompletados }"
                                            :color="!datosPasajerosCompletados ? 'grey' : (step >= 1 ? miColorAzul : miColorNaranja)"
                                            :text-color="!datosPasajerosCompletados ? 'black' : (step >= 1 ? miColorNaranja : miColorAzul)"
                                            style="font-size: 1.2rem;" :disabled="!datosPasajerosCompletados">
                                            Enviar Petición de Reserva
                                            <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                        </v-chip>
                                    </v-row>
                                </v-col>
                            </v-row>


                            <!-- Step 4: Envío del presupuesto -->
                            <v-row v-if="step === 4" justify="center" class="mt-12">
                                <v-col cols="12" sm="8" md="6" class="text-center">
                                    <!-- Enviando presupuesto -->
                                    <v-card v-if="loadingEnviandoPresupuesto"
                                        class="pa-6 card-personalizada slide-card">
                                        <div class="mt-4 flying-document-container">
                                            <v-icon class="flying-document" :color="miColorNaranja"
                                                size="64">mdi-file-document-outline</v-icon>
                                            <div class="wind-line wind-line-1"></div>
                                            <div class="wind-line wind-line-2"></div>
                                            <div class="wind-line wind-line-3"></div>
                                        </div>
                                        <div class="mt-4 pulse-text">
                                            <h2 :style="{ color: miColorAzul }">{{ $t('mensajes.enviando_presupuesto')
                                            }}</h2>
                                        </div>
                                    </v-card>
                                    <!-- Card Final Presupuesto enviado -->
                                    <v-card v-else class="pa-6 card-personalizada slide-card">
                                        <v-card-text>
                                            <v-row justify="center" class="mb-4">
                                                <h1> {{ $t('mensajes.presupuesto_enviado') }}</h1>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>

                                    <!-- Card Resumen Presupuesto -->
                                    <v-card v-if="this.camino && !loadingEnviandoPresupuesto"
                                        class="mt-6 pa-6 card-personalizada slide-card">
                                        <v-card-text>
                                            <v-row justify="center" class="mb-4">
                                                <v-col cols="4" align="center">
                                                    <v-img v-if="this.camino.etapas[0].imagen_base64"
                                                        :src="this.camino.etapas[0].imagen_base64" width="200px"
                                                        height="200px" style="border-radius: 20px;"></v-img>
                                                </v-col>
                                                <v-col align="start">
                                                    <p>
                                                        {{ this.language == 'en' ? this.camino.resumen_EN :
                                                            this.language == 'de' ? this.camino.resumen_DE :
                                                                this.camino.resumen }}
                                                    </p>


                                                </v-col>
                                            </v-row>

                                            <v-row class="mt-4 mb-2" justify="end">
                                                <v-chip link @click="_irAWebAlCamino()" large
                                                    class="ma-2 px-8 mr-8 hover-color"
                                                    :color="step >= 1 ? miColorAzul : miColorNaranja"
                                                    :text-color="step >= 1 ? miColorNaranja : miColorAzul"
                                                    style="font-size: 1.2rem;">
                                                    {{ $t('mensajes.ir_al_camino') }}
                                                    <v-icon size="2rem" right>mdi-arrow-right</v-icon>
                                                </v-chip>
                                            </v-row>
                                        </v-card-text>
                                    </v-card>


                                </v-col>
                            </v-row>

                        </v-container>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </div>
</template>

<script>
import { RESERVAS_CONFIG } from '@/config/reservas.js'
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    props: {
        idiomaInterfaz: {
            type: String,
            default: 'es'
        }
    },
    data() {
        return {
            RESERVAS_CONFIG,
            language: 'es',
            selectedCamino: null,
            selectedAgencia: '',
            selectedLanguage: 'ES',
            mostrarSolicitud: false,
            cargandoFiltros: false,
            ultimoFiltroAplicado: '',
            step: 1,
            admin: false,
            serviciosNoIncluidos: [],
            serviciosIncCancelados: [],
            serviciosIncluidos: [],

            loadingEnviandoPresupuesto: false,

            tipoDeDocumentos: [
                { name: 'DNI', value: 'DNI' },
                { name: 'NIE', value: 'NIE' },
                { name: 'PASAPORTE', value: 'PASAPORTE' },
            ],

            miColorNaranja: '#FF9C00',
            miColorAzul: '#191970',
            miColorVerde: '#2E7D32',
            miColorAmarillo: '#FFF6E5',
            showFechaInicio: false,
            showFechaFinal: false,
            importe_presupuestado: 0,
            descripcionImporteReserva: '',
            descripcionImporteServicios: '',

            modelReserva: {
                codigo_agencia: '',
                fecha_inicio: null,
                fecha_llegada: null,
                cant_peregrinos: 0,
                cant_habitaciones_individuales: 0,
                cant_habitaciones_dobles: 0,
                cant_habitaciones_dobles_matrimoniales: 0,
                cant_habitaciones_triples: 0,
                importe_presupuestado: 0,
                importe_reserva: 0,
                importe_servicios: 0,
                descripcion_importe_presupuestado: '',
                descripcion_importe_reserva: '',
                descripcion_importe_servicios: '',
                tarifa_nocheextra_ind: null,
                tarifa_nocheextra_doble: null,
                tarifa_nocheextra_triple: null,
                desgloce_nochesextras: false,
                origen_id: 1,
                tienePendientes: false,
                creada_por_id: null,
                servicios_inc_cancelados: '',
                comentarios: '',
                cliente: {
                    nombre: '',
                    apellidos: '',
                    telefono: '',
                    email: '',
                    aceptaPolitica: true,
                    aceptaNovedades: false
                }
            },

            pasajeros: [],
            nochesextras: [],
            trasladosExtras: [],
            serviciosExtras: [],

            codigoPaisSeleccionado: null,

            precio_ind: 0,
            precio_doble: 0,
            precio_triple: 0

        };
    },
    computed: {
        ...mapState("caminos", ["camino", "agencia", "caminos", "agencias", "languages"]),
        ...mapGetters('paises', ['getCodigosPais']),
        ...mapState('auth', ['user']),

        codigosPais() {
            return this.getCodigosPais;
        },
        caminosPermitidosIds() {
            if (this.admin || !this.user || !this.user.origen) {
                return null;
            }

            const raw = this.user.origen.caminos_permitidos;
            if (raw === null || raw === undefined || raw === '') {
                return null;
            }

            try {
                const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
                const ids = parsed && Array.isArray(parsed.caminos_id) ? parsed.caminos_id : [];
                return ids.map(id => Number(id)).filter(id => !Number.isNaN(id));
            } catch (error) {
                return null;
            }
        },
        caminosDisponibles() {
            if (!Array.isArray(this.caminos)) {
                return [];
            }

            if (!Array.isArray(this.caminosPermitidosIds)) {
                return this.caminos;
            }

            return this.caminos.filter(camino => this.caminosPermitidosIds.includes(Number(camino.id)));
        },

        filtrosSeleccionados() {
            const tieneCamino = !!this.selectedCamino;
            const tieneIdioma = !!this.selectedLanguage;
            const tieneAgencia = this.admin ? !!this.selectedAgencia : true;
            return tieneCamino && tieneIdioma && tieneAgencia;
        },

        datosPasajerosCompletados() {
            return this.step === 5 && this.pasajeros.every(pasajero => pasajero.nombre && pasajero.primer_apellido && pasajero.documento && pasajero.tipo_documento);
        },

        esAgencia() {
            return this.agencia != null && this.agencia.id != 1;
        },

        datosClienteCompletos() {
            const cliente = this.modelReserva && this.modelReserva.cliente ? this.modelReserva.cliente : {};
            const nombre = cliente.nombre ? cliente.nombre.toString().trim() : '';
            const telefono = cliente.telefono ? cliente.telefono.toString().trim() : '';
            const email = cliente.email ? cliente.email.toString().trim() : '';

            return !!(
                nombre &&
                telefono &&
                email &&
                this._emailValido(email)
            );
        },

        puedeRecibirPresupuesto() {
            return this.modelReserva.cliente.aceptaPolitica && this.datosClienteCompletos;
        },

        tienePendientes() {
            return this.serviciosNoIncluidos.some(servicio => this._servicioTieneTarifaPendiente(servicio));
        },

        puedeCompletarPeticionReserva() {
            return this.modelReserva.cliente.aceptaPolitica && !this.tienePendientes;
        },

        bloquearEmailClientePorPendientes() {
            return this.esAgencia && this.tienePendientes;
        },

        /*serviciosIncluidos() {
            if (this.camino) {
                return this.camino.servicios
                           .filter(servicio => servicio.esta_habilitado && servicio.esta_incluido)
                           .map(servicio => ({
                        ...servicio,
                        seleccionado: false
                    }));
            }
            return [];
        },*/

        datosMinimosCompletados() {
            if (this.camino) {
                if (this.step === 1 || this.step === 2 || this.step === 3 || this.step === 5) {
                   // const codigoAgencia = this.modelReserva.codigo_agencia ? this.modelReserva.codigo_agencia.toString().trim() : '';
                    return this.modelReserva.cant_peregrinos > 0 && //!!codigoAgencia &&
                        this.modelReserva.fecha_inicio &&
                        (this.modelReserva.cant_habitaciones_individuales > 0 ||
                            this.modelReserva.cant_habitaciones_dobles > 0 ||
                            this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ||
                            this.modelReserva.cant_habitaciones_triples > 0);
                } /*else if (this.step === 4) {
                    return this.modelReserva.cliente.nombre && this.modelReserva.cliente.email;
                }*/ else if (this.step === 4) {
                    return true;
                }
            }
            return false;
        },

        importeReserva() {
            if (!this.camino || !this.datosMinimosCompletados) return 0;

            const tarifaActual = this.obtenerTarifaActual();
            const suplemento = this.obtenerSuplementoTarifa(tarifaActual);
            const factorSuplemento = 1 + (suplemento / 100);
            let nochesConSuplemento = this.calcularNochesConSuplemento(tarifaActual);
            let nochesTotales = this.calcularNochesTotales();

            let importeTotal = 0;
            let descripcion = '';

            if (!suplemento || nochesConSuplemento == 0) {
                importeTotal = (
                    Number((this.modelReserva.cant_habitaciones_individuales * Math.ceil(parseFloat(this.precio_ind))).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles * Math.ceil(parseFloat(this.precio_doble))).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * Math.ceil(parseFloat(this.precio_doble))).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_triples * Math.ceil(parseFloat(this.precio_triple))).toFixed(2))
                );
                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(this.precio_ind).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * this.precio_ind).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(this.precio_doble).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(this.precio_doble).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * this.precio_doble).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(this.precio_triple).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * this.precio_triple).toFixed(2)} €` : '');

                this.modelReserva.descripcion_importe_reserva = this.descripcionImporteReserva.replace(/<br>/g, '\n').replace(/<b>/g, '').replace(/<\/b>/g, '');
                return parseFloat(importeTotal).toFixed(2);
            }

            if (suplemento > 0 && nochesTotales == nochesConSuplemento) {
                const precioIndConSuplemento = Math.ceil(parseFloat(this.precio_ind) * factorSuplemento);
                const precioDobleConSuplemento = Math.ceil(parseFloat(this.precio_doble) * factorSuplemento);
                const precioTripleConSuplemento = Math.ceil(parseFloat(this.precio_triple) * factorSuplemento);

                importeTotal = (
                    Number((this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2))
                );

                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €<br>` : '');

                this.modelReserva.descripcion_importe_reserva = this.descripcionImporteReserva.replace(/<br>/g, '\n')
                    .replace(/<b>(Tarifas con Suplemento)<\/b>/g, '');

                return parseFloat(importeTotal).toFixed(2);
            }

            if (suplemento > 0 && nochesTotales > nochesConSuplemento) {
                const precioIndSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_ind) / nochesTotales);
                const precioDobleSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_doble) / nochesTotales);
                const precioTripleSinSuplementoPorNoche = Math.ceil(parseFloat(this.precio_triple) / nochesTotales);

                const precioIndConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_ind) * factorSuplemento) / nochesTotales);
                const precioDobleConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_doble) * factorSuplemento) / nochesTotales);
                const precioTripleConSuplementoPorNoche = Math.ceil((parseFloat(this.precio_triple) * factorSuplemento) / nochesTotales);

                const precioIndConSuplemento = Math.ceil(precioIndSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioIndConSuplementoPorNoche * nochesConSuplemento);
                const precioDobleConSuplemento = Math.ceil(precioDobleSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioDobleConSuplementoPorNoche * nochesConSuplemento);
                const precioTripleConSuplemento = Math.ceil(precioTripleSinSuplementoPorNoche * (nochesTotales - nochesConSuplemento) + precioTripleConSuplementoPorNoche * nochesConSuplemento);

                importeTotal = (
                    Number((this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)) +
                    Number((this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2))
                );
                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €<br>` : '');

                this.modelReserva.descripcion_importe_reserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${parseFloat(precioIndConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_individuales * precioIndConSuplemento).toFixed(2)} €<br>` : '') +

                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles_matrimoniales * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +

                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${parseFloat(precioDobleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_dobles * precioDobleConSuplemento).toFixed(2)} €<br>` : '') +

                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${parseFloat(precioTripleConSuplemento).toFixed(2)} € ..... ${parseFloat(this.modelReserva.cant_habitaciones_triples * precioTripleConSuplemento).toFixed(2)} €<br>` : '');

                this.modelReserva.descripcion_importe_reserva = this.modelReserva.descripcion_importe_reserva.replace(/<br>/g, '\n');

                return parseFloat(importeTotal).toFixed(2);
            }

            /*

            if (this.camino.suplemento && this.camino.suplemento > 0 && nochesJulioAgosto > 0) {
               

                let precioSinSuplemento = (
                    this.modelReserva.cant_habitaciones_individuales * this.precio_ind +
                    this.modelReserva.cant_habitaciones_dobles * this.precio_doble +
                    this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble +
                    this.modelReserva.cant_habitaciones_triples * this.precio_triple
                );

                let precioSinSuplementoPorDia = (precioSinSuplemento / nochesTotales).toFixed(2);
                let precioConSuplemento = precioSinSuplemento + (precioSinSuplemento * this.camino.suplemento / 100);
                let precioConSuplementoPorDia = (precioConSuplemento / nochesTotales).toFixed(2);

                let importeTotalSinSuplemento = (precioSinSuplementoPorDia * (nochesTotales - nochesJulioAgosto)).toFixed(2);
                let importeTotalConSuplemento = (precioConSuplementoPorDia * nochesJulioAgosto).toFixed(2);

                importeTotal = (parseFloat(importeTotalSinSuplemento) + parseFloat(importeTotalConSuplemento)).toFixed(2);

                // Guardamos la descripción en una variable separada para no causar reactividad
                this.descripcionImporteReserva =
                    `Noches sin suplemento: ${nochesTotales - nochesJulioAgosto}<br>` +
                    `Noches con suplemento: ${nochesJulioAgosto}<br>` +
                    `Precio sin suplemento: ${precioSinSuplemento} €<br>` +
                    `Precio con suplemento: ${precioConSuplemento} €<br>` +
                    `Precio sin suplemento por día: (${precioSinSuplemento} € / ${nochesTotales} noches) = ${precioSinSuplementoPorDia} €<br>` +
                    `Precio con suplemento por día: (${precioConSuplemento} € / ${nochesTotales} noches) = ${precioConSuplementoPorDia} €<br>` +
                    `Importe total sin suplemento: (${precioSinSuplementoPorDia} € x ${nochesTotales - nochesJulioAgosto} noches) = ${importeTotalSinSuplemento} €<br>` +
                    `Importe total con suplemento: (${precioConSuplementoPorDia} € x ${nochesJulioAgosto} noches) = ${importeTotalConSuplemento} €<br>` +
                    `Importe total: (${importeTotalSinSuplemento} € + ${importeTotalConSuplemento} €) = ${importeTotal} €`;

            } else {
                importeTotal = (
                    this.modelReserva.cant_habitaciones_individuales * this.precio_ind +
                    this.modelReserva.cant_habitaciones_dobles * this.precio_doble +
                    this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble +
                    this.modelReserva.cant_habitaciones_triples * this.precio_triple
                );

                // Guardamos la descripción en una variable separada
                this.descripcionImporteReserva =
                    (this.modelReserva.cant_habitaciones_individuales > 0 ?
                        `${this.modelReserva.cant_habitaciones_individuales} ${this.$i18n.locale === 'es' ? 'Ind' : this.$i18n.locale === 'en' ? 'Single' : 'Einzelzimmer'} x ${this.precio_ind} € ..... ${this.modelReserva.cant_habitaciones_individuales * this.precio_ind} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles} ${this.$i18n.locale === 'es' ? 'Doble (2 camas Ind)' : this.$i18n.locale === 'en' ? 'Double (2 single beds)' : 'Doppelzimmer (2 Einzelbetten)'} x ${this.precio_doble} € ..... ${this.modelReserva.cant_habitaciones_dobles * this.precio_doble} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0 ?
                        `${this.modelReserva.cant_habitaciones_dobles_matrimoniales} ${this.$i18n.locale === 'es' ? 'Doble (cama matrimonial)' : this.$i18n.locale === 'en' ? 'Double (1 bed)' : 'Doppelzimmer (1 Doppelbett)'} x ${this.precio_doble} € ..... ${this.modelReserva.cant_habitaciones_dobles_matrimoniales * this.precio_doble} €<br>` : '') +
                    (this.modelReserva.cant_habitaciones_triples > 0 ?
                        `${this.modelReserva.cant_habitaciones_triples} ${this.$i18n.locale === 'es' ? 'Triple' : this.$i18n.locale === 'en' ? 'Triple' : 'Dreibettzimmer'} x ${this.precio_triple} € ..... ${this.modelReserva.cant_habitaciones_triples * this.precio_triple} €` : '');
            }

            return parseFloat(Math.round(parseFloat(importeTotal))).toFixed(2);*/
        },

        importeComision() {
            return parseFloat(this.importeReserva * this.comisionAgencia / 100).toFixed(2);
        },

        comisionAgencia() {
            const comision = parseInt(this.user && this.user.origen ? this.user.origen.comision : 0, 10);
            return Number.isNaN(comision) ? 0 : comision;
        },

        importeNeto() {
            return parseFloat(this.importeReserva - this.importeComision).toFixed(2);
        },

        importeServiciosNumerico() {
            let importe = 0;
            this.descripcionImporteServicios = '';

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {

                    if (servicio.seleccionado && servicio.titulo !== 'Noche extra' && servicio.titulo !== 'Traslados extra' && servicio.titulo !== 'Servicios extra') {
                        let tarifa = parseFloat(this._calcularTarifaDeServicio(servicio)).toFixed(2);
                        if (servicio.x_reserva) {
                            importe += parseFloat(tarifa);
                        } else {
                            let importeServicio = parseFloat(tarifa) * this.modelReserva.cant_peregrinos;
                            importe += importeServicio;
                        }
                        this.descripcionImporteServicios += '• ' + this.getTituloServicio(servicio) + ' ..... ' + (this._calcularTarifaDeServicioWithPersona(servicio) == 0 ? ' - ' : this._calcularTarifaDeServicioWithPersona(servicio))
                            + ' €<br>';
                        this.descripcionImporteServicios += this._getSubtituloServicioWithPersona(servicio) + (this._calcularTarifaDeServicioWithPersona(servicio) == 0 ? (' ' + this.$t('mensajes.servicios.pendiente_de_tarifa')) : '') + '<br>';
                    }
                }
            }
            this.descripcionImporteServicios += '<br>';

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {
                    if (servicio.titulo == 'Noche extra' && servicio.seleccionado) {
                        let importeEstaNocheExtra = 0;
                        for (let noche of this.nochesextras) {
                            importeEstaNocheExtra = 0;
                            if (noche.tarifa_ind > 0 && this.modelReserva.cant_habitaciones_individuales > 0) {
                                importeEstaNocheExtra += (this.modelReserva.cant_habitaciones_individuales * noche.tarifa_ind);
                            }
                            if (noche.tarifa_doble > 0 && (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0)) {
                                importeEstaNocheExtra += ((this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) * noche.tarifa_doble);
                            }
                            if (noche.tarifa_triple > 0 && this.modelReserva.cant_habitaciones_triples > 0) {
                                importeEstaNocheExtra += (this.modelReserva.cant_habitaciones_triples * noche.tarifa_triple);
                            }
                            importe += importeEstaNocheExtra;
                            this.descripcionImporteServicios += '• ' + this.$t('mensajes.servicios.noche_extra_en') + ' ' + noche.localidad + ' ..... ' + (importeEstaNocheExtra > 0 ? Number(importeEstaNocheExtra).toFixed(2) : ' - ') + ' €<br>';
                            this.descripcionImporteServicios += this.$t('mensajes.servicios.pendiente_de_tarifa') + '<br>';

                        }
                    }

                }
            }

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {
                    if (servicio.titulo == 'Traslados extra' && servicio.seleccionado) {
                        for (let trasladoextra of this.trasladosExtras) {
                            importe += Number(trasladoextra.importe);
                            this.descripcionImporteServicios += '• ' + this.$t('mensajes.servicios.traslado_extra') + ': ' + trasladoextra.descripcion + ' ..... - €<br>';
                            this.descripcionImporteServicios += this.$t('mensajes.servicios.pendiente_de_tarifa') + '<br>';
                        }
                    }

                }
            }

            for (let servicio of this.serviciosNoIncluidos) {
                if (servicio.seleccionado) {
                    if (servicio.titulo == 'Servicios extra' && servicio.seleccionado) {
                        for (let servicioExtra of this.serviciosExtras) {
                            importe += Number(servicioExtra.importe);
                            this.descripcionImporteServicios += '• ' + this.$t('mensajes.servicios.servicio_extra') + ': ' + servicioExtra.descripcion + ' ..... - €<br>';
                            this.descripcionImporteServicios += this.$t('mensajes.servicios.pendiente_de_tarifa') + '<br>';
                        }
                    }

                }
            }

            return parseFloat(importe).toFixed(2);
        },

        importeServicios() {
            const importe = this.importeServiciosNumerico;
            const hayServiciosSeleccionados = this.serviciosNoIncluidos.some(servicio => servicio.seleccionado);

            if (hayServiciosSeleccionados && Number(importe) === 0) {
                return '-';
            }

            return importe;
        },

        importeServiciosFormateado() {
            return this.importeServicios === '-' ? '- €' : this.importeServicios + ' €';
        },

        importeTotal() {
            if (!this.esAgencia) {
                return Math.ceil(parseFloat(parseFloat(this.importeReserva) + parseFloat(this.importeServiciosNumerico))).toFixed(2);
            } else {
                return parseFloat(parseFloat(this.importeReserva) + parseFloat(this.importeServiciosNumerico)).toFixed(2);
            }
        },

        importeTotalNeto() {
            return parseFloat(parseFloat(this.importeTotal) - parseFloat(this.importeComision)).toFixed(2);
        },

        listadoPuntosFinales() {
            const res = [];
            if (this.camino) {
                for (let etapa of this.camino.etapas) {
                    res.push(etapa.final_punto.nombre);
                }
            }
            return res;
        },

    },
    created() {
        // Inicializar con España (primer país de la lista)
        this.codigoPaisSeleccionado = this.codigosPais.find(pais => pais.code === 'ES');
    },
    mounted() {
        const camino_id = this.$route.params.camino_id;
        const agencia = this.$route.params.agencia;
        this.admin = this.$route.params.admin ? this.$route.params.admin == 'adm' : false;
        const idiomaInterfaz = this.aplicarIdiomaInterfaz(this.$route.params.language || this.$i18n.locale);
        this.selectedLanguage = idiomaInterfaz.toUpperCase();
        this.language = idiomaInterfaz;

        if (agencia) {
            this.selectedAgencia = agencia;
        }
        if (camino_id) {
            this.selectedCamino = Number(camino_id);
        }

        this._cargarOpcionesDeFiltro().then(() => {
            if (this.filtrosSeleccionados) {
                this._aplicarFiltros();
            }
        });

        if (this.user) {
            this.modelReserva.creada_por_id = this.user.id;
        }

    },
    watch: {
        idiomaInterfaz(language) {
            const idiomaDocumentacion = this.normalizarIdioma(language).toUpperCase();
            if (this.selectedLanguage !== idiomaDocumentacion) {
                this.selectedLanguage = idiomaDocumentacion;
            }
        },
        '$route.params.language'(language) {
            this.aplicarIdiomaInterfaz(language || this.$i18n.locale);
        },
        tienePendientes: {
            immediate: true,
            handler(value) {
                this.modelReserva.tienePendientes = value;
            }
        },
        selectedCamino() {
            this._intentarAplicarFiltros();
        },
        selectedLanguage() {
            this.language = this.normalizarIdioma(this.selectedLanguage);
            this._intentarAplicarFiltros();
        },
        selectedAgencia() {
            this._intentarAplicarFiltros();
        }
    },
    methods: {
        ...mapActions("caminos", ["getCamino", "getCaminos", "getAgencias", "getAgencia", "createReserva", "confirmarReserva"]),

        normalizarIdioma(language) {
            const idioma = String(language || 'es').toLowerCase();
            return ['es', 'en', 'de'].includes(idioma) ? idioma : 'es';
        },

        aplicarIdiomaInterfaz(language) {
            const idiomaValido = this.normalizarIdioma(language);
            this.$i18n.locale = idiomaValido;
            return idiomaValido;
        },

        async _cargarOpcionesDeFiltro() {
            await this.getCaminos();
            if (this.selectedCamino && !this.caminosDisponibles.some(camino => Number(camino.id) === Number(this.selectedCamino))) {
                this.selectedCamino = null;
            }
            if (this.admin) {
                await this.getAgencias();
            }
        },

        async _aplicarFiltros() {
            if (!this.filtrosSeleccionados) {
                return;
            }

            this.cargandoFiltros = true;
            this.mostrarSolicitud = false;
            this.step = 1;

            if (this.selectedAgencia) {
                await this._getAgencia(this.selectedAgencia);
            }
            await this._getCamino(this.selectedCamino);

            this.mostrarSolicitud = !!this.camino;
            this.cargandoFiltros = false;
        },

        _intentarAplicarFiltros() {
            if (this.cargandoFiltros) {
                return;
            }
            if (!this.filtrosSeleccionados) {
                this.mostrarSolicitud = false;
                this.ultimoFiltroAplicado = '';
                return;
            }

            const filtroKey = `${this.selectedCamino}-${this.selectedLanguage}-${this.admin ? this.selectedAgencia : 'na'}`;
            if (filtroKey === this.ultimoFiltroAplicado) {
                return;
            }
            this.ultimoFiltroAplicado = filtroKey;
            this._aplicarFiltros();
        },

        async _getCamino(id) {
            const res = await this.getCamino([id]);
            if (this.camino) {
                this.serviciosNoIncluidos = this.camino.servicios
                    .filter(servicio => servicio.esta_habilitado && !servicio.esta_incluido)
                    .map(servicio => ({
                        ...servicio,
                        seleccionado: false
                    }));

                this.serviciosIncluidos = this.camino.servicios
                    .filter(servicio => servicio.esta_habilitado && servicio.esta_incluido)
                    .map(servicio => ({
                        ...servicio,
                        seleccionado: true
                    }));

                // Recalcula fechas y tarifas al cambiar el camino seleccionado
                this._calcularFechaLlegada();
                this.actualizarTarifasCamino();
            }
        },

        async _getAgencia(agencia) {
            const res = await this.getAgencia([agencia]);
            if (this.agencia && this.esAgencia) {
                // this.modelReserva.cliente.nombre = this.agencia.nombre;
                // this.modelReserva.cliente.telefono = this.agencia.telefono;
                // this.modelReserva.cliente.email = this.agencia.email;
                // this.modelReserva.cliente.aceptaPolitica = true;
                this.modelReserva.origen_id = this.agencia.id;
            }
        },

        isValidDocument(tipo, documento) {

            if (!documento || documento.trim() === '') return true;

            const tipoDocumento = String(tipo).toUpperCase();

            switch (tipoDocumento) {
                case 'DNI':
                    return /^[0-9]{8}[A-Z]$/.test(documento);
                case 'NIE':
                    return /^[XYZ][0-9]{7,8}[A-Z]$/.test(documento);
                case 'Pasaporte':
                    return /^[A-Za-z0-9\-]{5,20}$/.test(documento);
                default:
                    return true;
            }
        },

        async _pedirDatosPasajeros() {
            if (this.esAgencia) {
                this.step = 4;
                this.loadingEnviandoPresupuesto = true;

                const hash = await this._createReserva();
                this.loadingEnviandoPresupuesto = false;

                if (hash) {
                    this.$router.push({
                        name: 'registroViajerosAgencia',
                        params: {
                            language: this.language.toLowerCase(),
                            hash
                        }
                    });
                    return;
                }
            }

            this.pasajeros = [];
            this.pasajeros = Array.from({ length: this.modelReserva.cant_peregrinos }, () => ({
                nombre: '',
                primer_apellido: '',
                tipo_documento: 'DNI',
                documento: '',
            }));
            if (this.pasajeros.length > 0) {
                this.pasajeros[0].nombre = this.modelReserva.cliente.nombre;
                this.pasajeros[0].primer_apellido = this.modelReserva.cliente.apellidos;
            }
            this.step = 5;
        },

        _agregarNocheExtraVacia(localidad) {
            this.nochesextras.push({
                localidad: localidad,
                tarifa_ind: 0,
                tarifa_doble: 0,
                tarifa_triple: 0,
            });
            this._calcularFechaLlegada();
        },

        _agregarTrasladoExtraVacio() {
            this.trasladosExtras.push({
                descripcion: '',
                importe: 0,
            });
        },

        _agregarServicioExtraVacio() {
            this.serviciosExtras.push({
                descripcion: '',
                importe: 0,
            });
        },

        onEliminarNoche(index) {
            this.nochesextras.splice(index, 1);
            this._calcularFechaLlegada();
        },

        onEliminarTrasladoExtra(index) {
            this.trasladosExtras.splice(index, 1);
        },

        onEliminarServicioExtra(index) {
            this.serviciosExtras.splice(index, 1);
        },

        onCancelarServicioInc(servicio, seleccionado) {
            servicio.seleccionado = !seleccionado;
        },

        onServicioSeleccionado(servicio) {
            if (servicio.titulo == 'Noche extra') {
                if (servicio.seleccionado) {
                    if (this.nochesextras.length == 0) {
                        this._agregarNocheExtraVacia('');
                    }
                } else {
                    this.nochesextras = [];
                    this._calcularFechaLlegada();
                }
            }

            if (servicio.titulo == 'Traslados extra') {
                if (servicio.seleccionado) {
                    if (this.trasladosExtras.length == 0) {
                        this._agregarTrasladoExtraVacio();
                    }
                } else {
                    this.trasladosExtras = [];
                }
            }

            if (servicio.titulo == 'Servicios extra') {
                if (servicio.seleccionado) {
                    if (this.serviciosExtras.length == 0) {
                        this._agregarServicioExtraVacio();
                    }
                } else {
                    this.serviciosExtras = [];
                }
            }

            if (servicio.titulo.includes('Traslado privado')) {
                if (servicio.seleccionado) {

                } else {
                    servicio.descripcion = '';
                    servicio.importe = 0;
                }
            }
        },

        _irAWebAlCamino() {
            if (this.language == 'en') {
                window.open(this.camino.link_web, '_blank');
            } else if (this.language == 'de') {
                window.open(this.camino.link_web, '_blank');
            } else {
                window.open(this.camino.link_web, '_blank');
            }
        },

        _irANuevoPresupuesto() {
            if (!this.admin) {
                this.mostrarSolicitud = false;
                this.selectedCamino = null;
                this.step = 1;
            } else {
                this.$router.push({ name: 'formularioInicial' });
            }
        },

        _cambiarStep(step) {
            this.step = step;
        },

        _emailValido(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        },

        _enviarPresupuestoAAgencia() {
            if (this.esAgencia) {
                if (!this.modelReserva.cliente.email || this.modelReserva.cliente.email === this.agencia.email) {
                    return true;
                }
            }
            return false;
        },

        _enviarPresupuestoAlClienteFinal() {
            if (this.esAgencia) {
                if (this.tienePendientes) {
                    return false;
                }
                if (this._emailValido(this.modelReserva.cliente.email) && this.modelReserva.cliente.email !== this.agencia.email) {
                    return true;
                }
            }
            return false;
        },

        _activadoEnvioDePresupuestoDesdeAgencia() {
            if (this.modelReserva.cliente.aceptaPolitica && this.esAgencia && (this.tienePendientes || this._enviarPresupuestoAAgencia() || this._enviarPresupuestoAlClienteFinal())) {
                return true;
            }
            return false;
        },

        _servicioTieneTarifaPendiente(servicio) {
            if (!servicio || !servicio.seleccionado) {
                return false;
            }

            if (
                servicio.titulo == 'Noche extra' ||
                servicio.titulo == 'Traslados extra' ||
                servicio.titulo == 'Servicios extra'
            ) {
                return true;
            }

            if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
                return true;
            }

            return Number(this._calcularTarifaDeServicioWithPersona(servicio)) === 0;
        },

        crearFechaLocal(fecha) {
            if (!fecha) return null;
            if (fecha instanceof Date) {
                return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
            }

            const fechaTexto = String(fecha).slice(0, 10);
            const [year, month, day] = fechaTexto.split('-').map(Number);

            if (year && month && day) {
                return new Date(year, month - 1, day);
            }

            const fechaParseada = new Date(fecha);
            return new Date(fechaParseada.getFullYear(), fechaParseada.getMonth(), fechaParseada.getDate());
        },

        obtenerTarifaActual() {
            if (!this.camino || !this.modelReserva.fecha_inicio) {
                return null;
            }

            return this.encontrarTarifaPorFecha(this.modelReserva.fecha_inicio);
        },

        obtenerSuplementoTarifa(tarifa = this.obtenerTarifaActual()) {
            const suplemento = Number(tarifa && tarifa.suplemento);
            return Number.isFinite(suplemento) && suplemento > 0 ? suplemento : 0;
        },

        calcularNochesConSuplemento(tarifa = this.obtenerTarifaActual()) {
            if (!this.modelReserva.fecha_inicio || !this.modelReserva.fecha_llegada || !tarifa) return 0;

            const suplemento = this.obtenerSuplementoTarifa(tarifa);
            if (suplemento <= 0 || !tarifa.suplemento_fecha_desde || !tarifa.suplemento_fecha_hasta) return 0;

            let noches = 0;
            let fechaActual = this.crearFechaLocal(this.modelReserva.fecha_inicio);
            const fechaLlegada = this.crearFechaLocal(this.modelReserva.fecha_llegada);
            const fechaSuplementoDesde = this.crearFechaLocal(tarifa.suplemento_fecha_desde);
            const fechaSuplementoHasta = this.crearFechaLocal(tarifa.suplemento_fecha_hasta);

            while (fechaActual < fechaLlegada) {
                if (fechaActual >= fechaSuplementoDesde && fechaActual <= fechaSuplementoHasta) {
                    noches++;
                }
                fechaActual.setDate(fechaActual.getDate() + 1);
            }

            return noches;
        },

        calcularNochesTotales() {
            if (!this.modelReserva.fecha_inicio || !this.modelReserva.fecha_llegada) return 0;

            const inicio = this.crearFechaLocal(this.modelReserva.fecha_inicio);
            const llegada = this.crearFechaLocal(this.modelReserva.fecha_llegada);
            const diferencia = llegada.getTime() - inicio.getTime();
            return Math.ceil(diferencia / (1000 * 3600 * 24));
        },



        _getSubtitulo(servicio) {
            if (servicio) {
                if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
                    return this.$t('mensajes.servicios.pendiente_de_tarifa')
                }
                if (servicio.x_reserva == 1) {
                    return this.$t('mensajes.servicios.subtitulo_desde', { tarifa: this._calcularTarifaDeServicio(servicio) });
                }

                if (servicio.x_persona == 1) {
                    return this.$t('mensajes.servicios.subtitulo_por_persona', { tarifa: this._calcularTarifaDeServicio(servicio) });
                }

            }
            return '';
        },

        _getSubtituloServicioWithPersona(servicio) {
            if (servicio) {

                /*if (this.admin && servicio.titulo.includes('Traslado privado a')) {
                    return '';
                }*/

                if (servicio.titulo.includes('Traslado privado')) {
                    if (servicio.descripcion === '' || servicio.descripcion === null) {
                        return '';
                    }
                    return '(' + servicio.descripcion + ')';
                }

                if (servicio.titulo == 'Noche extra' && servicio.seleccionado) {
                    var result = '';

                    for (let noche of this.nochesextras) {
                        if (noche.localidad != '') {
                            result += '• Noche extra en ' + noche.localidad + '\n';
                            if (noche.tarifa_ind > 0 && this.modelReserva.cant_habitaciones_individuales > 0) {
                                result += '(' + this.modelReserva.cant_habitaciones_individuales + (this.language === 'en' ? ' Single x ' : this.language === 'de' ? ' Einzelzimmer x ' : ' Ind x ') + noche.tarifa_ind + '€)';
                            }
                            if (noche.tarifa_doble > 0 && (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0)) {
                                result += '(' + (this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) + (this.language === 'en' ? ' Double x ' : this.language === 'de' ? ' Doppelzimmer x ' : ' Doble x ') + noche.tarifa_doble + '€)';
                            }
                            if (noche.tarifa_triple > 0 && this.modelReserva.cant_habitaciones_triples > 0) {
                                result += '(' + this.modelReserva.cant_habitaciones_triples + (this.language === 'en' ? ' Triple x ' : this.language === 'de' ? ' Dreibettzimmer x ' : ' Triple x ') + noche.tarifa_triple + '€)';
                            }
                            result += '.....' + (Number(noche.tarifa_ind * this.modelReserva.cant_habitaciones_individuales +
                                noche.tarifa_doble * this.modelReserva.cant_habitaciones_dobles +
                                noche.tarifa_doble * this.modelReserva.cant_habitaciones_dobles_matrimoniales +
                                noche.tarifa_triple * this.modelReserva.cant_habitaciones_triples).toFixed(2)) + ' €\n';
                        }
                    }
                    return result;
                }

                if (servicio.titulo == 'Traslados extra' && servicio.seleccionado) {
                    var result = '';

                    for (let traslado of this.trasladosExtras) {
                        if (traslado.descripcion != '') {
                            result += '• Traslado extra: ' + traslado.descripcion + ' ..... ' + Number(traslado.importe).toFixed(2) + '\n';
                        }
                    }
                    return result;
                }

                if (servicio.titulo == 'Servicios extra' && servicio.seleccionado) {
                    var result = '';

                    for (let servicioExtra of this.serviciosExtras) {
                        if (servicioExtra.descripcion != '') {
                            result += '• ' + servicioExtra.descripcion + ' ..... ' + Number(servicioExtra.importe).toFixed(2) + '\n';
                        }
                    }
                    return result;
                }


                if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
                    return this.$t('mensajes.servicios.pendiente_de_tarifa')
                }
                if (servicio.x_reserva == 1) {
                    return "(" + this._calcularTarifaDeServicioWithPersona(servicio) + "€)";
                }

                if (servicio.x_persona == 1) {
                    return this.$t('mensajes.servicios.subtitulo_por_persona_con_persona', { tarifa: this._calcularTarifaDeServicio(servicio), personas: this.modelReserva.cant_peregrinos });
                }

            }
            return '';
        },

        _calcularTarifaDeServicio(servicio) {
            if (servicio.titulo.includes('Traslado privado') && servicio.importe > 0) {
                return servicio.importe;
            }

            if (servicio.titulo.includes('Excursión')) {
                const fechaLlegada = new Date(this.modelReserva.fecha_llegada);
                const year = fechaLlegada.getFullYear();

                if (year == 2026) {
                    return servicio.tarifa_2026;
                }

                if (year == 2027) {
                    return servicio.tarifa_2027;
                }

                return servicio.tarifa;
            }

            if (!servicio || !servicio.tarifa) {
                return 0;
            }

            if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {

                return 0;
            }

            let tarifa = parseFloat(servicio.tarifa);

            if (servicio.x_reserva) {
                if (this.modelReserva.cant_peregrinos <= servicio.max_pendiente) {
                    return parseFloat(tarifa);
                }
            }

            if (servicio.x_noche) {
                tarifa = tarifa * this.camino.noches;
            }
            if (servicio.x_etapa) {
                tarifa = tarifa * (this.camino.noches - 1);
            }

            return parseFloat(tarifa);
        },

        _calcularTarifaDeServicioWithPersona(servicio) {

            if (servicio.titulo.includes('Traslado privado') && servicio.importe > 0) {
                return Number(servicio.importe).toFixed(2);
            }

            if (servicio.titulo == 'Noche extra' && servicio.seleccionado) {
                var res = 0;

                for (let noche of this.nochesextras) {
                    if (noche.tarifa_ind > 0 && this.modelReserva.cant_habitaciones_individuales > 0) {
                        res = res + (this.modelReserva.cant_habitaciones_individuales * noche.tarifa_ind);
                    }
                    if (noche.tarifa_doble > 0 && (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0)) {
                        res = res + ((this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) * noche.tarifa_doble);
                    }
                    if (noche.tarifa_triple > 0 && this.modelReserva.cant_habitaciones_triples > 0) {
                        res = res + (this.modelReserva.cant_habitaciones_triples * noche.tarifa_triple);
                    }
                }
                return res;
            }

            if (servicio.titulo == 'Traslados extra' && servicio.seleccionado) {
                var res = 0;

                for (let traslado of this.trasladosExtras) {
                    if (traslado.importe > 0) {
                        res = res + Number(traslado.importe);
                    }
                }
                return res;
            }

            if (servicio.titulo == 'Servicios extra' && servicio.seleccionado) {
                var res = 0;

                for (let servicioExtra of this.serviciosExtras) {
                    if (servicioExtra.importe > 0) {
                        res = res + Number(servicioExtra.importe);
                    }
                }
                return res;
            }

            if (!servicio || !servicio.tarifa) {
                return 0;
            }

            if (this.modelReserva.cant_peregrinos > servicio.max_pendiente) {
                return 0;
            }

            let tarifa = this._calcularTarifaDeServicio(servicio);


            let result = 0;

            if (servicio.x_reserva) {
                if (this.modelReserva.cant_peregrinos <= servicio.max_pendiente) {
                    return parseFloat(tarifa);
                }
            }

            if (servicio.x_persona) {
                result = tarifa * this.modelReserva.cant_peregrinos;
            }

            return Number(result).toFixed(2);
        },

        formatearFecha(fecha) {
            if (!fecha) return ''
            const caption_inicio = new Date(fecha).toLocaleDateString(this.$i18n.locale, {
                day: '2-digit',
                month: 'long'
            });

            const caption_llegada = new Date(this.modelReserva.fecha_llegada).toLocaleDateString(this.$i18n.locale, {
                day: '2-digit',
                month: 'long',
                year: 'numeric'
            });
            return caption_inicio + ' - ' + caption_llegada;
        },

        _changeFechaInicio() {
            this._calcularFechaLlegada();
        },

        _setCantidadPeregrinos(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_peregrinos++;
            } else if (operacion === '-' && this.modelReserva.cant_peregrinos > 0) {
                this.modelReserva.cant_peregrinos--;
            }
        },

        _setCantidadHabitacionesIndividuales(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_individuales++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_individuales > 0) {
                this.modelReserva.cant_habitaciones_individuales--;
            }
            this._calcularCantidadPeregrinos();
        },

        getTituloServicio(servicio) {
            if (!this.language) {
                return servicio.titulo; // Retornamos el título por defecto
            }

            if (this.language.toLowerCase() === 'es') {
                return servicio.titulo;
            } else if (this.language.toLowerCase() === 'en') {
                return servicio.titulo_EN;
            } else if (this.language.toLowerCase() === 'de') {
                return servicio.titulo_DE;
            }
            return servicio.titulo;
        },

        getTituloCamino(camino) {
            if (!camino) return '';

            const idioma = String(this.$i18n.locale || this.language || 'es').toLowerCase();
            const tituloPorIdioma = idioma === 'en'
                ? camino.titulo_EN
                : idioma === 'de'
                    ? camino.titulo_DE
                    : camino.titulo;

            return tituloPorIdioma || camino.titulo || '';
        },

        _setCantidadHabitacionesDobles(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_dobles++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_dobles > 0) {
                this.modelReserva.cant_habitaciones_dobles--;
            }
            this._calcularCantidadPeregrinos();
        },

        _setCantidadHabitacionesDoblesMatrimoniales(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_dobles_matrimoniales++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0) {
                this.modelReserva.cant_habitaciones_dobles_matrimoniales--;
            }
            this._calcularCantidadPeregrinos();
        },

        _setCantidadHabitacionesTriples(operacion) {
            if (operacion === '+') {
                this.modelReserva.cant_habitaciones_triples++;
            } else if (operacion === '-' && this.modelReserva.cant_habitaciones_triples > 0) {
                this.modelReserva.cant_habitaciones_triples--;
            }
            this._calcularCantidadPeregrinos();
        },

        _parseFechaISO(fecha) {
            if (!fecha) return null;
            if (fecha instanceof Date && !isNaN(fecha)) {
                return new Date(Date.UTC(fecha.getFullYear(), fecha.getMonth(), fecha.getDate()));
            }
            if (typeof fecha === 'string') {
                const partes = fecha.split('-');
                if (partes.length !== 3) return null;
                const year = Number(partes[0]);
                const month = Number(partes[1]);
                const day = Number(partes[2]);
                if (!year || !month || !day) return null;
                return new Date(Date.UTC(year, month - 1, day));
            }
            return null;
        },

        _formatFechaISO(fecha) {
            if (!(fecha instanceof Date) || isNaN(fecha)) return null;
            const year = fecha.getUTCFullYear();
            const month = String(fecha.getUTCMonth() + 1).padStart(2, '0');
            const day = String(fecha.getUTCDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },

        _calcularFechaLlegada() {
            if (this.camino != null && this.camino.etapas.length > 0) {
                const fechaInicio = this._parseFechaISO(this.modelReserva.fecha_inicio);
                if (!fechaInicio) {
                    return;
                }

                let dias = this.camino.etapas.length + this.nochesextras.length;
                if (this.camino.con_etapa_final == 0) {
                    dias -= 1;
                }

                fechaInicio.setUTCDate(fechaInicio.getUTCDate() + dias);
                this.modelReserva.fecha_llegada = this._formatFechaISO(fechaInicio);

                this.actualizarTarifasCamino();
            }
        },

        actualizarTarifasCamino() {
            if (this.camino != null && this.modelReserva.fecha_inicio != null) {
                const tarifaEncontrada = this.encontrarTarifaPorFecha(this.modelReserva.fecha_inicio);

                if (tarifaEncontrada) {
                    this.precio_ind = tarifaEncontrada.precio_ind;
                    this.precio_doble = tarifaEncontrada.precio_doble;
                    this.precio_triple = tarifaEncontrada.precio_triple;
                }
            }
        },

        encontrarTarifaPorFecha(fechaInicio) {
            if (!this.camino || !this.camino.tarifas || !Array.isArray(this.camino.tarifas)) {
                return null;
            }
            const fechaInicioDate = this.crearFechaLocal(fechaInicio);
            const tarifaEncontrada = this.camino.tarifas.find(tarifa => {
                const fechaDesde = this.crearFechaLocal(tarifa.fecha_desde);
                const fechaHasta = this.crearFechaLocal(tarifa.fecha_hasta);
                return fechaInicioDate >= fechaDesde && fechaInicioDate <= fechaHasta;
            });
            return tarifaEncontrada || null;
        },


        _calcularCantidadPeregrinos() {
            this.modelReserva.cant_peregrinos =
                this.modelReserva.cant_habitaciones_individuales * 1 +
                this.modelReserva.cant_habitaciones_dobles * 2 +
                this.modelReserva.cant_habitaciones_dobles_matrimoniales * 2 +
                this.modelReserva.cant_habitaciones_triples * 3;
        },

        async _recibirPresupuesto() {
            if (!this.esAgencia && !this.puedeRecibirPresupuesto) {
                return;
            }

            const emailClienteOriginal = this.esAgencia ? this.modelReserva.cliente.email : '';
            this.step = 4;
           /* if (this.esAgencia) {
                this.modelReserva.cliente.telefono = this.agencia.telefono;
                if (!this.modelReserva.cliente.nombre) {
                    this.modelReserva.cliente.nombre = this.agencia.nombre;
                }
                if (!this.modelReserva.cliente.apellidos) {
                    this.modelReserva.cliente.apellidos = "";
                }
                if (this.tienePendientes || !this.modelReserva.cliente.email) {
                    this.modelReserva.cliente.email = this.agencia.email;
                }
            }*/
            this.loadingEnviandoPresupuesto = true;
            try {
                await this._createReserva();
            } finally {
                this.loadingEnviandoPresupuesto = false;

               /* if (this.esAgencia && this.tienePendientes && emailClienteOriginal && emailClienteOriginal !== this.agencia.email) {
                    this.modelReserva.cliente.email = emailClienteOriginal;
                }*/
            }

        },

        actualizarTienePendientes() {
            this.modelReserva.tienePendientes = this.tienePendientes;
        },

        extraerHashReserva(response) {
            if (!response || typeof response !== 'object') return null;

            const posiblesHashes = [
                response.hash,
                response.reserva_hash,
                response.data && response.data.hash,
                response.data && response.data.reserva_hash,
                response.reserva && response.reserva.hash,
                response.reserva && response.reserva.reserva_hash,
                response.data && response.data.reserva && response.data.reserva.hash,
                response.data && response.data.reserva && response.data.reserva.reserva_hash
            ];

            const hash = posiblesHashes.find(value => value && value.toString().trim() !== '');
            return hash ? hash.toString().trim() : null;
        },

        async _createReserva() {
            this.modelReserva.importe_presupuestado = this.importeTotal;
            this.modelReserva.importe_reserva = this.importeReserva;
            this.modelReserva.importe_servicios = this.importeServiciosNumerico;

            this.generateDescriptionImportePresupuestado();
            if (!this.esAgencia) {
                this.modelReserva.cliente.telefono = this.codigoPaisSeleccionado.dial_code + this.modelReserva.cliente.telefono;
            }

            const serviciosSeleccionados = this.serviciosNoIncluidos.filter(servicio => servicio.seleccionado).map(servicio => ({
                servicio_id: servicio.id,
                titulo: this.getTituloServicio(servicio),
                descripcion: this._getSubtituloServicioWithPersona(servicio),
                importe: this._calcularTarifaDeServicioWithPersona(servicio)
            }));

            const serviciosSeleccionadosFromExtras = this.actualizarServiciosSeleccionadosFromExtras(serviciosSeleccionados);
            this.actualizarTienePendientes();

            this.modelReserva.servicios_inc_cancelados = '';
            for (let servicio of this.serviciosIncluidos) {
                if (!servicio.seleccionado) {
                    this.modelReserva.servicios_inc_cancelados += servicio.id + ';';
                }
            }
            if (this.modelReserva.servicios_inc_cancelados == '') {
                this.modelReserva.servicios_inc_cancelados = null;
            }

            const response = await this.createReserva([this.camino, this.modelReserva, serviciosSeleccionadosFromExtras, this.language.toUpperCase()]);
            if (!this.esAgencia) {
                this.modelReserva.cliente.telefono = this.modelReserva.cliente.telefono.replace(this.codigoPaisSeleccionado.dial_code, '');
            }
            return this.extraerHashReserva(response);
        },

        actualizarServiciosSeleccionadosFromExtras(serviciosSeleccionados) {
            let result = [];
            for (let servicio of serviciosSeleccionados) {
                if (servicio.titulo == 'Noche extra' || servicio.titulo == 'Extra nights' || servicio.titulo == 'Zusatznächte') {
                    for (let noche of this.nochesextras) {
                        let importeEstaNocheExtra = 0;
                        let tituloEsteServicio = '';
                        let descripcionEsteServicio = '';
                        if (noche.tarifa_ind > 0 && this.modelReserva.cant_habitaciones_individuales > 0) {
                            importeEstaNocheExtra += (this.modelReserva.cant_habitaciones_individuales * noche.tarifa_ind);
                        }
                        if (noche.tarifa_doble > 0 && (this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0)) {
                            importeEstaNocheExtra += ((this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) * noche.tarifa_doble);
                        }
                        if (noche.tarifa_triple > 0 && this.modelReserva.cant_habitaciones_triples > 0) {
                            importeEstaNocheExtra += (this.modelReserva.cant_habitaciones_triples * noche.tarifa_triple);
                        }
                        tituloEsteServicio = this.$t('mensajes.servicios.noche_extra_en') + ' ' + noche.localidad;
                        descripcionEsteServicio += '(';
                        if (this.modelReserva.cant_habitaciones_individuales > 0 && noche.tarifa_ind > 0)
                            descripcionEsteServicio += this.modelReserva.cant_habitaciones_individuales + (this.language === 'en' ? ' Single x ' : this.language === 'de' ? ' Einzelzimmer x ' : ' Ind x ') + Number(noche.tarifa_ind).toFixed(2) + '€, ';
                        if ((this.modelReserva.cant_habitaciones_dobles > 0 || this.modelReserva.cant_habitaciones_dobles_matrimoniales > 0) && noche.tarifa_doble > 0)
                            descripcionEsteServicio += (this.modelReserva.cant_habitaciones_dobles + this.modelReserva.cant_habitaciones_dobles_matrimoniales) + (this.language === 'en' ? ' Double x ' : this.language === 'de' ? ' Doppelzimmer x ' : ' Doble x ') + Number(noche.tarifa_doble).toFixed(2) + '€, ';
                        if (this.modelReserva.cant_habitaciones_triples > 0 && noche.tarifa_triple > 0)
                            descripcionEsteServicio += this.modelReserva.cant_habitaciones_triples + (this.language === 'en' ? ' Triple x ' : this.language === 'de' ? ' Dreibettzimmer x ' : ' Triple x ') + Number(noche.tarifa_triple).toFixed(2) + '€';
                        descripcionEsteServicio += ')';

                        result.push({
                            servicio_id: servicio.servicio_id,
                            titulo: tituloEsteServicio,
                            descripcion: descripcionEsteServicio.replace(', )', ')'),
                            importe: importeEstaNocheExtra
                        });
                    }
                } else if (servicio.titulo == 'Traslados extra' || servicio.titulo == 'Extra transfers' || servicio.titulo == 'Zusätzliche Transfers') {
                    for (let trasladoExtra of this.trasladosExtras) {

                        result.push({
                            servicio_id: servicio.servicio_id,
                            titulo: servicio.titulo,
                            descripcion: trasladoExtra.descripcion,
                            importe: trasladoExtra.importe
                        });
                    }

                } else if (servicio.titulo == 'Servicios extra' || servicio.titulo == 'Extra services' || servicio.titulo == 'Zusatzleistungen') {
                    for (let servicioExtra of this.serviciosExtras) {

                        result.push({
                            servicio_id: servicio.servicio_id,
                            titulo: servicio.titulo,
                            descripcion: servicioExtra.descripcion,
                            importe: servicioExtra.importe
                        });
                    }

                }

                else {
                    result.push(servicio);
                }

            }
            return result;
        },

        _enviarConfirmacionReserva() {
            this.step = 4;
            if (this.esAgencia) {
                this.modelReserva.cliente.telefono = this.agencia.telefono;
                if (!this.modelReserva.cliente.nombre) {
                    this.modelReserva.cliente.nombre = this.agencia.nombre;
                }
                if (!this.modelReserva.cliente.apellidos) {
                    this.modelReserva.cliente.apellidos = "";
                }
                if (!this.modelReserva.cliente.email) {
                    this.modelReserva.cliente.email = this.agencia.email;
                }
            }
            this.loadingEnviandoPresupuesto = true;
            this._confirmarReserva();
        },

        generateDescriptionImportePresupuestado() {
            //  this.modelReserva.descripcion_importe_reserva = this.descripcionImporteReserva.replace(/<br>/g, '\n').replace(/<b>/g, '').replace(/<\/b>/g, '');
            this.modelReserva.descripcion_importe_servicios = this.descripcionImporteServicios.replace(/<br>/g, '\n');
            if (!this.esAgencia) {

                this.modelReserva.descripcion_importe_presupuestado = this.$t('mensajes.datos_reserva.importe_reserva') + this.importeReserva + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.descripcion_importe_reserva + '\n\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.servicios_agregados') + this.importeServiciosFormateado + '\n';
                this.modelReserva.descripcion_importe_presupuestado += this.modelReserva.descripcion_importe_servicios + '\n\n';

                /*for (let servicio of this.serviciosNoIncluidos) {
                    if (servicio.seleccionado) {

                        this.modelReserva.descripcion_importe_presupuestado += this.getTituloServicio(servicio) + ' ' + this._getSubtituloServicioWithPersona(servicio) + ': ';

                        if (this._calcularTarifaDeServicioWithPersona(servicio) == 0) {
                            this.modelReserva.descripcion_importe_presupuestado += ' - ';
                        } else {
                            this.modelReserva.descripcion_importe_presupuestado += this._calcularTarifaDeServicioWithPersona(servicio) + ' €\n';
                        }

                    }
                }*/
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.importe_total') + this.importeTotal + ' €';
            } else {
                this.modelReserva.descripcion_importe_presupuestado = this.$t('mensajes.datos_reserva.importe_reserva') + ' (PVP)' + this.importeReserva + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.comision_agencia') + this.importeComision + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.importe_neto_agencia') + this.importeNeto + ' €\n';
                this.modelReserva.descripcion_importe_presupuestado += this.descripcionImporteReserva.replace(/<br>/g, '') + '\n\n';
                this.modelReserva.descripcion_importe_presupuestado += this.$t('mensajes.datos_reserva.servicios_agregados') + ' (Neto)' + this.importeServiciosFormateado + '\n';
                this.modelReserva.descripcion_importe_presupuestado += this.descripcionImporteServicios.replace(/<br>/g, '\n') + '\n\n';


                /*  for (let servicio of this.serviciosNoIncluidos) {
                      if (servicio.seleccionado) {
                          this.modelReserva.descripcion_importe_presupuestado += this.getTituloServicio(servicio) + ' ' + this._getSubtituloServicioWithPersona(servicio) + ': ';
  
                          if (this._calcularTarifaDeServicioWithPersona(servicio) == 0) {
                              this.modelReserva.descripcion_importe_presupuestado += ' - ';
                          } else {
                              this.modelReserva.descripcion_importe_presupuestado += this._calcularTarifaDeServicioWithPersona(servicio) + ' €\n';
                          }
  
                      }
                  }*/

                this.modelReserva.descripcion_importe_presupuestado += '\n' + this.$t('mensajes.datos_reserva.importe_total') + ' (PVP)' + this.importeTotal + ' €';
                this.modelReserva.descripcion_importe_presupuestado += '\n' + this.$t('mensajes.datos_reserva.importe_total') + ' (Neto)' + this.importeTotalNeto + ' €';
            }


        },

        async _confirmarReserva() {
            this.modelReserva.importe_presupuestado = this.importeTotal;
            this.modelReserva.importe_reserva = this.importeReserva;
            this.modelReserva.importe_servicios = this.importeServiciosNumerico;
            this.generateDescriptionImportePresupuestado();
            if (!this.esAgencia) {
                this.modelReserva.cliente.telefono = this.codigoPaisSeleccionado.dial_code + this.modelReserva.cliente.telefono;
            }

            const serviciosSeleccionados = this.serviciosNoIncluidos.filter(servicio => servicio.seleccionado).map(servicio => ({
                servicio_id: servicio.id,
                titulo: this.getTituloServicio(servicio),
                descripcion: this._getSubtituloServicioWithPersona(servicio),
                importe: this._calcularTarifaDeServicioWithPersona(servicio)
            }));

            const response = await this.confirmarReserva([this.camino, this.modelReserva, serviciosSeleccionados, this.pasajeros, this.language.toUpperCase()]);
            if (!this.esAgencia) {
                this.modelReserva.cliente.telefono = this.modelReserva.cliente.telefono.replace(this.codigoPaisSeleccionado.dial_code, '');
            }
            this.loadingEnviandoPresupuesto = false;
        },

        _Siguiente() {
            this.step++;
            if (this.step > 3) {
                this.step = 1;
            }

        },

        scrollToServiciosIncluidos() {
            const target = this.$refs.serviciosIncluidosCentral;
            if (!target) return;
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },

        _Atras() {
            this.step--;
            if (this.step < 1) {
                this.step = 3;
            }
        },
    }
};
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.5.0/css/flag-icon.min.css';

.card-personalizada {
    border: none !important;
    border-radius: 15px !important;
}

.flying-document-container {
    position: relative;
    height: 150px;
    width: 100%;
    overflow: hidden;
}

.flying-document {
    position: relative;
    animation: fly 2s infinite ease-in-out;
}

.wind-line {
    position: absolute;
    height: 2px;
    background: #FF9C00;
    opacity: 0.6;
    animation: wind 2s infinite ease-in-out;
}

.wind-line-1 {
    width: 50px;
    top: 40%;
    left: 30%;
}

.wind-line-2 {
    width: 30px;
    top: 50%;
    left: 45%;
    animation-delay: 0.2s;
}

.wind-line-3 {
    width: 40px;
    top: 60%;
    left: 35%;
    animation-delay: 0.4s;
}


@keyframes fly {
    0% {
        transform: translateX(-100%) translateY(20px) rotate(0deg);
    }

    50% {
        transform: translateX(0) translateY(0px) rotate(5deg);
    }

    100% {
        transform: translateX(100%) translateY(20px) rotate(0deg);
    }
}

@keyframes wind {
    0% {
        transform: translateX(-100%) scaleX(0.5);
        opacity: 0;
    }

    50% {
        opacity: 0.6;
    }

    100% {
        transform: translateX(100%) scaleX(1);
        opacity: 0;
    }
}

.pulse-text {
    animation: pulse 1.5s infinite;
}

@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.5;
    }

    100% {
        opacity: 1;
    }
}

.slide-card {
    animation: slideIn 0.5s ease-out;
}

@keyframes slideIn {
    from {
        transform: translateX(100%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card.v-leave-active {
    animation: slideOut 0.5s ease-in;
}

@keyframes slideOut {
    from {
        transform: translateX(0);
        opacity: 1;
    }

    to {
        transform: translateX(-100%);
        opacity: 0;
    }
}

.slide-card-up {
    animation: slideInUp 0.5s ease-out;
}

@keyframes slideInUp {
    from {
        transform: translateY(-100%);
        opacity: 0;
    }

    to {
        transform: translateY(0);
        opacity: 1;
    }
}

/* Para la animación de salida */
.slide-card-up.v-leave-active {
    animation: slideOutDown 0.5s ease-in;
}

.scroll-down-anim {
    animation: scrollDownHint 1.2s ease-in-out infinite;
}

@keyframes scrollDownHint {
    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(5px);
    }
}

@keyframes slideOutDown {
    from {
        transform: translateY(0);
        opacity: 1;
    }

    to {
        transform: translateY(100%);
        opacity: 0;
    }
}

.fade-card {
    animation: fadeInSoft 0.35s ease-out;
}

@keyframes fadeInSoft {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>
